export const WINNERS_DATA = [
  // //4nov
  // {
  //   name: 'name',
  //   username: 'username',
  //   imgSrc: 'imgSrc',
  // },
  // {
  //   name: 'name',
  //   username: 'username',
  //   imgSrc: 'imgSrc',
  // },
  // {
  //   name: 'name',
  //   username: 'username',
  //   imgSrc: 'imgSrc',
  // },
  // {
  //   name: 'name',
  //   username: 'username',
  //   imgSrc: 'imgSrc',
  // },
  // {
  //   name: 'name',
  //   username: 'username',
  //   imgSrc: 'imgSrc',
  // },
  // {
  //   name: 'name',
  //   username: 'username',
  //   imgSrc: 'imgSrc',
  // },
  //8nov
  {
    name: '#Artist',
    username: 'yashini',
    imgSrc: 'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/2024_nov/8/yashini.png',
  },
  {
    name: '#oopata',
    username: 'samyukthatadoju',
    imgSrc: 'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/2024_nov/8/samyukthatadoju.jpg',
  },
  {
    name: '#plants',
    username: 'zeramary',
    imgSrc: 'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/2024_nov/8/zeramary.jpg',
  },
  {
    name: '#shayar',
    username: 'Adarsh',
    imgSrc: 'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/2024_nov/8/Adarsh.jpg',
  },
  {
    name: '#Best',
    username: 'maturegirl',
    imgSrc: 'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/2024_nov/8/maturegirl.jpg',
  },
  //6nov
  {
    name: '#Celebrity',
    username: 'Smirthaspeaks',
    imgSrc: 'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/2024_nov/8/smirthaspeaks.png',
  },
  {
    name: '#exercise',
    username: '_fidato',
    imgSrc: 'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/2024_nov/8/Fidato.jpg',
  },
  {
    name: '#imperfectlyperfect',
    username: 'paathu_',
    imgSrc: 'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/2024_nov/8/paathu_.jpg',
  },
  {
    name: '#Shyari',
    username: 'shyam_',
    imgSrc: 'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/2024_nov/8/shyam_+(2).jpg',
  },
  {
    name: '#chhathpuja',
    username: 'rd_lko_',
    imgSrc: 'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/2024_nov/8/rd_lko_voice_.jpeg',
  },
  //4nov
  {
    name: '#Poochandi',
    username: 'vijiwithu',
    imgSrc: 'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/2024_oct/30/vijiwithu.jpeg',
  },
  {
    name: '#overuse',
    username: 'jackkk',
    imgSrc: 'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/2024_oct/30/Jack+.jpg',
  },
  {
    name: '#90shiphop',
    username: 'goonj_e_smriti',
    imgSrc: 'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/2024_oct/30/goonj_e_smriti.jpeg',
  },
  {
    name: '#90sNostalgia',
    username: 'riturocks',
    imgSrc: 'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/2024_oct/30/riturocks+copy.jpg',
  },
  //1nov
  {
    name: '#pastlife',
    username: 'divyavinni',
    imgSrc: 'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/2024_oct/30/divyavinni.jpg',
  },
  {
    name: '#Ai',
    username: 'drvenus',
    imgSrc: 'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/2024_oct/30/drvenus.jpg',
  },
  {
    name: '#song',
    username: 'Meena',
    imgSrc: 'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/2024_oct/30/meena+(1).png',
  },
  {
    name: '#Shyari',
    username: 'muskan_2',
    imgSrc: 'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/2024_oct/30/muskan_2.jpeg',
  },
  {
    name: '#Lovequote',
    username: '_fidato',
    imgSrc: 'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/2024_oct/30/_fidato.jpeg',
  },
  //30oct
  {
    name: '#Strokeday',
    username: 'vinimini',
    imgSrc: 'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/2024_oct/30/vinimini.jpeg',
  },
  {
    name: '#awaitedmovie',
    username: 'Hithaishini',
    imgSrc: 'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/2024_oct/30/hithaishini.jpeg',
  },
  {
    name: '#childinme',
    username: 'family4',
    imgSrc: 'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/2024_oct/30/family4+.jpg',
  },
  {
    name: '#Recipe',
    username: 'abhasharma',
    imgSrc: 'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/2024_oct/30/abhasharma.jpg',
  },
  {
    name: '#iamenough',
    username: 'maturegirl',
    imgSrc: 'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/2024_oct/30/maturegirl.jpg',
  },
  //28oct
  {
    name: '#Isloveenough ',
    username: 'rainy ',
    imgSrc: 'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/2024_oct/30/rainy.jpeg',
  },
  {
    name: '#shayri',
    username: 'Adarsh',
    imgSrc: 'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/2024_oct/30/Adarsh.jpg',
  },
  {
    name: '#DiwaliShopping',
    username: 'muskan_2',
    imgSrc: 'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/2024_oct/30/muskan_2.jpeg',
  },
  {
    name: '#KeepSmiling',
    username: 'annamariyam',
    imgSrc: 'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/2024_oct/30/annamariyam.jpg',
  },
  {
    name: '#ispend',
    username: 'gayupalakuri ',
    imgSrc: 'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/2024_oct/30/gayupalakuri+.jpg',
  },
  //27oct
  {
    name: '#sunday',
    username: 'shaaaann_06',
    imgSrc: 'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/2024_oct/30/shaaaann_06.jpg',
  },
  //25oct
  {
    name: '#Infoday',
    username: 'thrishaa',
    imgSrc: 'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/2024_oct/30/thrishaa.jpeg',
  },
  {
    name: '#music',
    username: 'rajeev8302',
    imgSrc: 'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/2024_oct/30/rajeev8302+(1).jpeg',
  },
  {
    name: '#Unspokenlove',
    username: 'riturocks',
    imgSrc: 'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/2024_oct/30/riturocks+copy.jpg',
  },
  {
    name: '#MoneyMinded',
    username: 'rjkhanishka',
    imgSrc: 'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/2024_oct/30/Rj+Khanishka.jpeg',
  },
  {
    name: '#examprepartion',
    username: 'listen2vin',
    imgSrc: 'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/2024_oct/30/Listen2vin.jpeg',
  },
  //23oct
  {
    name: '#Youtuber',
    username: 'vidhyavasan',
    imgSrc: 'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/2024_oct/30/vidhyavasan.jpeg',
  },
  {
    name: '#overratted',
    username: 'iam_ishoo',
    imgSrc: 'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/2024_oct/30/iam_ishoo.jpg',
  },
  {
    name: '#Diwali',
    username: 'aniteshm',
    imgSrc: 'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/2024_oct/30/aniteshm+(1).jpeg',
  },
  // {
  //   name: '#Recipe',
  //   username: 'rashmideep',
  //   imgSrc: 'imgSrc',
  // },
  {
    name: '#colour',
    username: 'sirim',
    imgSrc: 'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/2024_oct/30/sirim.jpg',
  },
  //21oct
  {
    name: '#show',
    username: 'yami2005',
    imgSrc: 'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/2024_oct/21/yami2005.jpeg',
  },
  {
    name: '#DiwaliShopping',
    username: 'muskan_2',
    imgSrc: 'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/2024_oct/21/muskan_2.jpeg',
  },
  {
    name: '#Diwali',
    username: 'Meena',
    imgSrc: 'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/2024_oct/21/meena+(1).png',
  },
  {
    name: '#Gallery',
    username: 'purplemochi',
    imgSrc: 'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/2024_oct/21/purplemochi.jpeg',
  },
  {
    name: '#youtube',
    username: 'Hithaishini',
    imgSrc: 'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/2024_oct/21/hithaishini.jpeg',
  },
  //18oct
  {
    name: '#worldspineday',
    username: 'aishu3',
    imgSrc: 'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/2024_oct/21/aishu3.jpeg',
  },
  {
    name: '#DiwaliShopping',
    username: 'rd_lko_voice_',
    imgSrc: 'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/2024_oct/21/rd_lko_voice_.jpeg',
  },
  {
    name: '#90shiphop',
    username: 'goonj_e_smriti',
    imgSrc: 'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/2024_oct/21/goonj_e_smriti.jpeg',
  },
  {
    name: '#BossDay',
    username: 'kavyajerry',
    imgSrc: 'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/2024_oct/21/Kavya.jpeg',
  },
  {
    name: '#travelpartner',
    username: 'eshanka02',
    imgSrc: 'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/2024_oct/21/eshanka02.jpeg',
  },
  //16oct
  {
    name: '#Success',
    username: 'devi_r',
    imgSrc: 'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/2024_oct/21/devi_r.jpeg',
  },
  {
    name: '#Fitness',
    username: 'anjubts',
    imgSrc: 'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/2024_oct/21/anjubts.jpg',
  },
  {
    name: '#Recipe',
    username: 'abhasharma',
    imgSrc: 'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/2024_oct/21/abhasharma.jpg',
  },
  {
    name: '#Unspokenlove',
    username: 'riturocks',
    imgSrc: 'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/2024_oct/21/riturocks+copy.jpg',
  },
  {
    name: '#confidence',
    username: 'jula.v.gopal',
    imgSrc: 'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/2024_oct/30/Jula+v+Gopal++(1).jpg',
  },
  {
    name: '#mentalhealth',
    username: 'keeruuu06',
    imgSrc: 'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/2024_oct/21/keeruuu06.jpg',
  },
  //14oct
  {
    name: '#salary',
    username: 'yuvideva',
    imgSrc: 'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/2024_oct/14/yuvideva.jpeg',
  },
  {
    name: '#nukse',
    username: 'shalinimishra30',
    imgSrc: 'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/2024_oct/14/shalinimishra30.jpeg',
  },
  {
    name: '#ComedyIn30',
    username: 'Meena ',
    imgSrc: 'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/2024_oct/14/meena+(1).png',
  },
  {
    name: '#Electronics',
    username: '_fidato',
    imgSrc: 'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/2024_oct/14/Fidato.jpg',
  },
  {
    name: '#focus',
    username: 'dishagowda08',
    imgSrc: 'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/2024_oct/14/dishagowda08.jpg',
  },
  //11oct
  {
    name: '#Nationalpostday',
    username: 'pkpkk',
    imgSrc: 'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/2024_oct/14/pkpkk.jpeg',
  },
  {
    name: '#RecentSong',
    username: 'Sailu_the_one',
    imgSrc: 'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/2024_oct/14/sailu_the_one.jpeg',
  },
  {
    name: '#iamenough',
    username: 'maturegirl',
    imgSrc: 'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/2024_oct/14/maturegirl.jpg',
  },
  {
    name: '#Recipe',
    username: 'abhasharma',
    imgSrc: 'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/2024_oct/14/abhasharma.jpg',
  },
  {
    name: '#specialday',
    username: 'varshagowda',
    imgSrc: 'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/2024_oct/14/varshagowda.jpg',
  },
  //9oct
  {
    name: '#Navratri',
    username: 'Yami2005',
    imgSrc: 'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/2024_oct/14/yami2005.jpeg',
  },
  {
    name: '#iamenough',
    username: 'maturegirl',
    imgSrc: 'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/2024_oct/14/maturegirl.jpg',
  },
  {
    name: '#WallDecore',
    username: 'bindassbhawna',
    imgSrc: 'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/2024_oct/14/bindassbhawna.jpg',
  },
  {
    name: '#Budget',
    username: 'satyasri_netha',
    imgSrc: 'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/2024_oct/14/Copy+of+Nagasatyarsiri.jpg',
  },
  {
    name: '#travel',
    username: '_saritha_',
    imgSrc: 'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/2024_oct/14/Saritha.jpg',
  },
  {
    name: '#funny',
    username: 'Sudarshana PG',
    imgSrc: 'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/2024_oct/14/Sudarshana+PG.jpg',
  },
  //7oct
  {
    name: '#MRI',
    username: '2323',
    imgSrc: 'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/2024_oct/14/2323.jpg',
  },
  {
    name: '#Navrati',
    username: 'muskan_2',
    imgSrc: 'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/2024_oct/14/muskan_2.jpeg',
  },
  {
    name: '#Mood',
    username: 'shalinimishra30',
    imgSrc: 'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/2024_oct/14/shalinimishra30.jpeg',
  },
  {
    name: '#lifecycle',
    username: 'radhikaumesh',
    imgSrc: 'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/2024_oct/14/radhikaumesh.jpg',
  },
  {
    name: '#30Secs',
    username: 'yashini',
    imgSrc: 'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/2024_oct/14/yashini.png',
  },
  //4oct
  {
    name: '#Kavithvam',
    username: 'purplemochi',
    imgSrc: 'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/2024_oct/14/purplemochi.jpeg',
  },
  {
    name: '#shayaar',
    username: 'Adarsh',
    imgSrc: 'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/2024_oct/14/Adarsh.jpg',
  },
  {
    name: '#LDR',
    username: 'abhasharma',
    imgSrc: 'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/2024_oct/14/abhasharma.jpg',
  },
  {
    name: '#worstdecision',
    username: 'deeksha05',
    imgSrc: 'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/2024_oct/14/deeksha05.jpg',
  },
  {
    name: '#Beauty',
    username: 'Shalumathu',
    imgSrc: 'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/2024_oct/14/shalumathu.jpeg',
  },
  //2oct
  {
    name: '#pachadi',
    username: 'vara',
    imgSrc: 'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/2024_oct/14/Vara.jpg',
  },
  {
    name: '#Navratri',
    username: 'rd_lko_voice_',
    imgSrc: 'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/2024_oct/14/rd_lko_voice_.jpeg',
  },
  {
    name: '#music',
    username: 'Meena ',
    imgSrc: 'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/2024_oct/14/meena+(1).png',
  },
  {
    name: '#mysurudaries',
    username: 'gunnjain',
    imgSrc: 'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/2024_oct/14/gunnjain+copy.jpg',
  },
  {
    name: '#Gandhiin30',
    username: 'ambili',
    imgSrc: 'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/2024_oct/21/Ambili.jpg',
  },
  {
    name: '#GandhiIn30',
    username: 'Chithu_talks',
    imgSrc: 'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/2024_oct/14/chithu_talks.jpeg',
  },
  //30sep
  {
    name: '#Saveelectricity',
    username: 'nidhyi',
    imgSrc: 'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/2024_sep/20-30/nidhyi.jpeg',
  },
  {
    name: '#NostalgiaBites',
    username: 'muskan_2',
    imgSrc: 'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/2024_sep/20-30/muskan_2.jpeg',
  },
  {
    name: '#howisthejosh',
    username: 'sona1234',
    imgSrc: 'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/2024_sep/20-30/sona1234.jpg',
  },
  {
    name: '#negativity',
    username: 'varshagowda',
    imgSrc: 'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/2024_sep/20-30/varshagowda.jpg',
  },
  {
    name: '#Prevent',
    username: 'kavyajerry',
    imgSrc: 'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/2024_sep/20-30/Kavya.jpeg',
  },
  //27sep
  {
    name: '#Grocery',
    username: 'Divyavinni',
    imgSrc: 'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/2024_sep/20-30/Divyavinni+.jpg',
  },
  {
    name: '#Teaorcoffee',
    username: 'gunnjain',
    imgSrc: 'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/2024_sep/20-30/gunnjain.WEBP',
  },
  {
    name: '#Regrets',
    username: 'fun_panromm',
    imgSrc: 'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/2024_sep/20-30/snehaaa+haha.jpeg',
  },
  {
    name: '#music',
    username: 'Meena',
    imgSrc: 'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/2024_sep/20-30/meena+(1).png',
  },
  {
    name: '#music',
    username: 'rajeev8302',
    imgSrc: 'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/2024_sep/20-30/rajeev8302+(1).jpeg',
  },
  //25sep
  {
    name: '#Change',
    username: 'Sailu_the_one',
    imgSrc: 'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/2024_sep/20-30/sailu_the_one.jpeg',
  },
  {
    name: '#Signlanguages',
    username: 'thrishaa',
    imgSrc: 'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/2024_sep/20-30/thrishaa.jpeg',
  },
  {
    name: '#TravelDiaries',
    username: 'bindassbhawna',
    imgSrc: 'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/2024_sep/20-30/bindassbhawna.jpg',
  },
  {
    name: '#potery',
    username: 'shalinimishra30',
    imgSrc: 'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/2024_sep/20-30/shalinimishra30.jpeg',
  },
  {
    name: '#girlythings',
    username: 'medha',
    imgSrc: 'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/2024_oct/14/medha.jpg',
  },
  //23sep
  {
    name: '#React',
    username: 'purplemochi',
    imgSrc: 'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/2024_oct/14/purplemochi.jpeg',
  },
  {
    name: '#MeraPowerSelf',
    username: 'rjjyoti',
    imgSrc: 'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/2024_sep/20-30/rjjyoti.jpeg',
  },
  {
    name: '#Foodnotifications',
    username: 'aish_28',
    imgSrc: 'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/2024_sep/20-30/aish_28.jpeg',
  },
  {
    name: '#music',
    username: 'Meena',
    imgSrc: 'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/2024_sep/20-30/meena+(1).png',
  },
  {
    name: '#foodhabits',
    username: 'iam_ishoo',
    imgSrc: 'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/2024_sep/20-30/iam_ishoo.jpg',
  },
  //20sep
  {
    name: '#scratchcard',
    username: 'Ssrilakshmi',
    imgSrc: 'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/2024_sep/20-30/ssrilakshmi.jpeg',
  },
  {
    name: '#homedecor',
    username: 'maturegirl',
    imgSrc: 'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/2024_sep/20-30/maturegirl.jpg',
  },
  {
    name: '#ShoppingApp',
    username: 'family4',
    imgSrc: 'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/2024_sep/20-30/family4.jpg',
  },
  {
    name: '#homedecor',
    username: 'sweety96',
    imgSrc: 'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/2024_sep/20-30/sweety96.jpg',
  },
  {
    name: '#Indiaeducation',
    username: 'Sudarshana PG',
    imgSrc: 'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/2024_sep/20-30/Sudarshana+PG.jpg',
  },
    //18sep
  {
    name: '#eveningsnack',
    username: 'iam_ishoo',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/2024_sep/18/iam_ishoo.jpg',
  },
  {
    name: '#music',
    username: 'Meena',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/2024_sep/18/meena+(1).png',
  },
  {
    name: '#music',
    username: 'rajeev8302',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/2024_sep/18/rajeev8302+(1).jpeg',
  },
  {
    name: '#Karuthu',
    username: '_fidato',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/2024_sep/18/Fidato.jpg',
  },
  {
    name: '#Dreamhome',
    username: 'skipsway',
    imgSrc: 'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/2024_sep/18/Shiju.jpg',
  },
  //16sep
  {
    name: '#tvremote',
    username: '.amizhtha_02',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/2024_sep/amizhtha_02.jpg',
  },
  {
    name: '#RANGEHINDI',
    username: 'abhasharma',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/2024_sep/abhasharma.jpg',
  },
  {
    name: '#motivation',
    username: 'star_adi',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/2024_sep/star_adi.jpeg',
  },
  //13sep
  {
    name: '#Marriage',
    username: 'yuvideva',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/2024_sep/yuvideva.jpeg',
  },
  {
    name: '#Poetry',
    username: 'shyam_',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/2024_sep/shyam_+(2).jpg',
  },
  {
    name: '#GaneshChaturthi',
    username: 'rd_lko_voice_',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/2024_sep/rd_lko_voice_.jpeg',
  },
  {
    name: '#Tips',
    username: 'vara',
    imgSrc: 'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/2024_sep/20-30/Vara.jpg',
  },
  //11sep
  {
    name: '#Actor',
    username: 'Gowthamlove',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/2024_sep/gowthamlove.jpeg',
  },
  {
    name: '#LocalBusiness',
    username: 'bindassbhawna',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/2024_sep/bindassbhawna.jpg',
  },
  {
    name: '#RadhaAshtami ',
    username: 'muskan_2',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/2024_sep/muskan_2.jpeg',
  },
  {
    name: '#Selflove',
    username: 'subhacts',
    imgSrc: 'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/2024_sep/18/SUBHA+CT.jpg',
  },
  {
    name: '#Ways',
    username: 'kavyajerry',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/2024_sep/Kavya.jpeg',
  },
  //9sep
  {
    name: '#PhysicalTherapy',
    username: '_fidato',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/2024_sep/Fidato.jpg',
  },
  {
    name: '#Cartoon',
    username: 'smirthaspeaks',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/2024_sep/smirthaspeaks.png',
  },
  //6sep
  {
    name: '#Life',
    username: 'purplemochi',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/2024_sep/purplemochi.jpeg',
  },
  {
    name: '#solotravel',
    username: 'Sudarshana PG',
    imgSrc: 'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/2024_sep/Sudarshana+PG.jpg',
  },
  {
    name: '#Myplace',
    username: 'rainy',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/2024_sep/rainy.jpeg',
  },
  {
    name: '#music',
    username: 'Meena',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/2024_sep/meena+(1).png',
  },
  {
    name: '#shayar',
    username: 'Adarsh',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/2024_sep/Adarsh.jpg',
  },
  //4sep
  {
    name: '#LaporPhone',
    username: 'kanza',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/2024_sep/kanza.jpeg',
  },
  {
    name: '#ParaOlympics',
    username: '2323',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/2024_sep/2323.jpg',
  },
  {
    name: '#solotravel',
    username: 'listen2vin',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/2024_sep/Listen2vin.jpeg',
  },
  //2sep
  {
    name: '#myaugust',
    username: 'amrutaammu',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/2024_sep/amrutaammu.jpeg',
  },
  {
    name: '#Care',
    username: 'sirim',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/2024_sep/Siri.jpg',
  },
  {
    name: '#nukse',
    username: 'shalinimishra30',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/2024_sep/shalinimishra30.jpeg',
  },
  {
    name: '#Poetry',
    username: 'shyam_',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/2024_sep/shyam_+(2).jpg',
  },
  {
    name: '#Outing',
    username: 'devi_r',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/2024_sep/devi_r.jpeg',
  },
  //30aug
  {
    name: '#Sports',
    username: 'yashini',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/2024_aug/30/yashini.png',
  },
  {
    name: '#Strategy',
    username: 'laxmi',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/2024_aug/30/Laxmi.jpg',
  },
  {
    name: '#Justicetovictim',
    username: 'Amatuer',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/2024_aug/30/amateur_poet.jpg',
  },
  {
    name: '#lifechanging',
    username: 'eshanka02',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/2024_aug/30/eshanka02.jpeg',
  },
  //28aug
  {
    name: '#Janmashtami',
    username: 'muskan_2',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/2024_aug/30/muskan_2.jpeg',
  },
  {
    name: '#MeraPowerSelf',
    username: 'rjjyoti',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/2024_aug/30/rjjyoti.jpeg',
  },
  {
    name: '#weight',
    username: 'rajir',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/2024_aug/30/rajir.jpeg',
  },
  {
    name: '#janamashtami',
    username: 'listen2vin',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/2024_aug/30/Listen2vin.jpeg',
  },
  //26aug
  {
    name: '#currentaffairs ',
    username: 'keeruuu06',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/2024_aug/30/keeruuu06.jpg',
  },
  {
    name: '#Interview',
    username: 'vijiwithu',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/2024_aug/30/vijiwithu.jpeg',
  },
  {
    name: '#newme',
    username: 'supersardarni',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/2024_aug/30/supersardarni.jpg',
  },
  {
    name: '#Janmashtami',
    username: 'mrenuka',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/2024_aug/30/mrenuka.jpeg',
  },
  {
    name: '#Why',
    username: 'purplemochi',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/2024_aug/30/purplemochi.jpeg',
  },
  //23aug
  {
    name: '#Kadijoke',
    username: 'nidhyi ',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/2024_aug/30/nidhyi.jpeg',
  },
  {
    name: '#Hygiene',
    username: 'kavyajerry',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/2024_aug/30/Kavya.jpeg',
  },
  {
    name: '#tvshows',
    username: 'Sudarshana PG',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/2024_aug/30/Sudarshana.jpg',
  },
  //21aug
  {
    name: '#worldphotographyday',
    username: 'Vansha',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/2024_aug/30/vansha.jpeg',
  },
  {
    name: '#Poetry',
    username: 'shyam_',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/2024_aug/30/shyam_+(2).jpg',
  },
  {
    name: '#VideoGames',
    username: '_fidato',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/2024_aug/30/Fidato.jpg',
  },
  {
    name: '#Rakshabandhan',
    username: 'jaya.life',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/2024_aug/30/jayalife.jpeg',
  },
  {
    name: '#womensafety',
    username: 'Sudarshana PG',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/2024_aug/30/Sudarshana.jpg',
  },
  {
    name: '#diltobacchahaiji',
    username: 'singwithmeetuuu',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/2024_aug/30/singwithmeetuuu.jpeg',
  },
  {
    name: '#Yaariyan',
    username: 'vivek1996',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/2024_aug/30/vivek1996.jpeg',
  },
  //19aug
  {
    name: '#actionmovie',
    username: 'deeksha05',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/2024_aug/19/deeksha05.jpg',
  },
  {
    name: '#Me',
    username: 'dhwity',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/2024_aug/19/dhwity.jpeg',
  },
  {
    name: '#howisthejosh',
    username: 'sona1234',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/2024_aug/19/sona1234.jpg',
  },
  {
    name: '#aazaadaawaaz',
    username: 'bindassbhawna',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/2024_aug/19/bindassbhawna.jpg',
  },
  //16aug
  {
    name: '#independenceweek',
    username: 'Adarsh',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/2024_aug/19/Adarsh.jpg',
  },
  {
    name: '#aazaadaawaaj',
    username: 'abhasharma',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/2024_aug/19/abhasharma.jpg',
  },
  {
    name: '#onlinevsoffline',
    username: 'rj_dharshu_',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/2024_aug/19/rj_dharshu_.jpeg',
  },
  {
    name: '#monsoon',
    username: 'amrutaammu',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/2024_aug/30/amrutaammu.jpeg',
  },
  //14aug
  {
    name: '#Kadhai',
    username: 'mayberrie06',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/2024_aug/19/mayberrie06.jpeg',
  },
  {
    name: '#Young',
    username: 'amirat._.hasan',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/2024_aug/30/Hasan+.jpg',
  },
  {
    name: '#independenceweek',
    username: 'riturocks',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/2024_aug/19/riturocks+copy.jpg',
  },
  {
    name: '#patrioticdialogue',
    username: 'anibha_muskan',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/2024_aug/19/anibha_muskan.png',
  },
  {
    name: '#villagelife ',
    username: 'listen2vin',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/2024_aug/30/Listen2vin.jpeg',
  },
  //12aug
  {
    name: '#childhoodgame',
    username: 'dishagowda08',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/2024_aug/12/dishagowda08.jpg',
  },
  {
    name: '#Retirement',
    username: 'samshitaraj',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/2024_aug/12/Samshitha+.jpg',
  },
  {
    name: '#worldlionday',
    username: 'chithu_talks',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/2024_aug/12/chithu_talks.jpeg',
  },
  {
    name: '#homeremedies',
    username: 'rashmisingh',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/2024_aug/12/rashmisingh.jpg',
  },
  {
    name: '#Tips',
    username: 'jaya.life',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/2024_aug/12/jayalife.jpeg',
  },
  //9aug
  {
    name: '#collegecanteen',
    username: '.amizhtha_02',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/2024_aug/12/amizhtha_02.jpeg',
  },
  {
    name: '#kannadainfluencer',
    username: 'listen2vin',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/2024_aug/12/Listen2vin.jpeg',
  },
  {
    name: '#poetry',
    username: 'shyam_',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/2024_aug/12/shyam_+(2).jpg',
  },
  {
    name: '#song',
    username: 'Meena',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/2024_aug/12/meena+(1).png',
  },
  {
    name: '#Reservation',
    username: '2323',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/2024_aug/12/2323.jpg',
  },
  //7aug
  {
    name: '#Birthdayparty',
    username: '_fidato',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/2024_aug/7/Fidato.jpg',
  },
  {
    name: '#spaceproblems',
    username: 'maturegirl',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/2024_aug/7/maturegirl.jpg',
  },
  {
    name: '#shayri',
    username: 'Adarsh',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/2024_aug/7/Adarsh.jpg',
  },
  {
    name: '#Block',
    username: 'rjkhanishka ',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/2024_aug/7/Rj+Khanishka.jpeg',
  },
  {
    name: '#nightout',
    username: 'iam_ishoo',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/2024_aug/7/iam_ishoo.jpg',
  },
  //5aug
  {
    name: '#Menissue',
    username: 'samyukthatadoju',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/2024_aug/5/Samyuktha+.jpg',
  },
  {
    name: '#kannadavlogs',
    username: 'Hithaishini',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/2024_aug/5/hithaishini.jpeg',
  },
  {
    name: '#Cherishing',
    username: 'rajir',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/2024_aug/5/rajir.jpeg',
  },
  {
    name: '#hindisong',
    username: 'shiva0',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/2024_aug/5/shiva0.jpg',
  },
  {
    name: '#selfcare',
    username: 'abhasharma',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/2024_aug/5/abhasharma.jpg',
  },
  //2aug
  {
    name: '#Adaimozhi',
    username: 'itsmefem',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/2024_aug/5/itsmefem.jpeg',
  },
  {
    name: '#comedy',
    username: 'listen2vin',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/2024_aug/5/Listen2vin.jpeg',
  },
  {
    name: '#Lag',
    username: 'purplemochi',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/2024_aug/5/purplemochi.jpeg',
  },
  {
    name: '#pyaarkijeet',
    username: 'riturocks',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/2024_aug/5/riturocks+copy.jpg',
  },
  {
    name: '#gaana',
    username: 'meena',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/2024_aug/5/meena+(1).png',
  },
  //31july
  {
    name: '#annoying ',
    username: 'Hithaishini ',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/2024_july/31/hithaishini.jpeg',
  },
  {
    name: '#nadipu',
    username: 'nidhyi',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/2024_july/31/nidhyi.jpeg',
  },
  {
    name: '#AI',
    username: 'laxmi',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/2024_july/31/Laxmi.jpg',
  },
  {
    name: '#online',
    username: 'abhasharma',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/2024_july/31/abhasharma.jpg',
  },
  {
    name: '#pasandeedahero',
    username: 'maturegirl',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/2024_july/31/maturegirl.jpg',
  },
  // {
  //   name: 'name',
  //   username: 'username',
  //   imgSrc: 'imgSrc',
  // },
  //29july
  {
    name: '#Nationalparentsday',
    username: 'devi_r',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/2024_july/31/devi_r.jpeg',
  },
  {
    name: '#History',
    username: 'kavyajerry',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/2024_july/31/Kavya.jpeg',
  },
  // {
  //   name: 'name',
  //   username: 'username',
  //   imgSrc: 'imgSrc',
  // },
  //26july
  {
    name: '#sacrifice',
    username: 'chushikworld',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/2024_july/26/chushikworld.png',
  },
  {
    name: '#Sentimental',
    username: 'rjalaknanda',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/2024_july/26/Alaknanda.jpeg',
  },
  {
    name: '#biggboss',
    username: 'dishagowda08',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/2024_july/26/dishagowda08.jpg',
  },
  {
    name: '#bestfriend',
    username: 'keeruuu06',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/2024_july/26/keeruuu06.jpg',
  },
  {
    name: '#worklifebalance',
    username: 'riturocks',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/2024_july/26/riturocks+copy.jpg',
  },
  {
    name: '#maankibaat',
    username: 'san_jay1',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/2024_july/26/san_jay1.jpg',
  },
  //24july
  {
    name: '#fakecomments',
    username: 'listen2vin',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/2024_july/24/Listen2vin.jpeg',
  },
  {
    name: '#DidYouKnow',
    username: 'Yuvideva',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/2024_july/24/yuvideva.jpeg',
  },
  {
    name: '#shivmahina',
    username: 'abhasharma',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/2024_july/24/abhasharma.jpg',
  },
  {
    name: '#poetry',
    username: 'shyam_',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/2024_july/24/shyam_+(2).jpg',
  },
  // {
  //   name: 'name',
  //   username: 'username',
  //   imgSrc: 'imgSrc',
  // },
  //22july
  {
    name: '#Poetry',
    username: 'shyam_',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/2024_july/22/shyam_+(2).jpg',
  },
  {
    name: '#gurupurnima',
    username: 'mairamoin09',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/2024_july/22/mairamoin09.jpg',
  },
  {
    name: '#DIDYOUKNOW',
    username: 'shalumathu',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/2024_july/22/Shalumathu.jpg',
  },
  {
    name: '#DabbuBalam',
    username: 'samshitaraj',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/2024_july/22/Samshitha+.jpg',
  },
  {
    name: '#Bangaloretraffic',
    username: 'poorvikanay',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/2024_july/22/poorvikanay+.jpg',
  },
  //19july
  {
    name: '#Film',
    username: 'fun_panromm',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/2024_july/22/fun_panromm.jpeg',
  },
  {
    name: '#loveatfirstsight',
    username: 'krishna123456',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/2024_july/22/krishna123456+(1).jpg',
  },
  {
    name: '#shayri',
    username: 'shyam_',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/2024_july/22/shyam_+(2).jpg',
  },
  {
    name: '#Parents',
    username: 'rjkhanishka',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/2024_july/22/Rj+Khanishka.jpeg',
  },
  {
    name: '#findinghappiness',
    username: 'Hithaishini ',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/2024_july/22/hithaishini.jpeg',
  },
  //17july
  {
    name: '#corruption',
    username: 'chaaotic_mind',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/2024_july/17/chaaotic_mind.jpg',
  },
  {
    name: '#Ads',
    username: 'pavithra96 ',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/2024_july/17/pavithra96.jpeg',
  },
  {
    name: '#Call',
    username: 'Sailu_the_one',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/2024_july/17/sailu_the_one.jpeg',
  },
  {
    name: '#HBDkatrina',
    username: 'anibha_muskan',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/2024_july/17/anibha_muskan.png',
  },
  {
    name: '#fairytale',
    username: 'iam_ishoo',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/2024_july/17/iam_ishoo.jpg',
  },
  //14july
  {
    name: '#FeedBack',
    username: 'sirim',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/2024_july/17/sirim.jpg',
  },
  {
    name: '#Parlour',
    username: 'ssrilakshmi ',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/2024_july/17/ssrilakshmi.jpeg',
  },
  {
    name: '#advise',
    username: 'poorvikanay',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/2024_july/17/poorvikanay.jpg',
  },
  // {
  //   name: 'name',
  //   username: 'username',
  //   imgSrc: 'imgSrc',
  // },
  //12july
  {
    name: '#fears',
    username: 'amrutaammu',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/2024_july/amrutaammu.jpeg',
  },
  {
    name: '#90sNostalgia',
    username: 'riturocks',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/2024_july/riturocks+copy.jpg',
  },
  {
    name: '#Hiddengem',
    username: 'sweety96',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/2024_july/sweety96.jpg',
  },
  {
    name: '#Twisted',
    username: 'Divyavinni',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/2024_july/Divyavinni+.jpg',
  },
  //10july
  {
    name: '#FlyingWorld',
    username: 'rjlatha',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/2024_july/rjlatha.png',
  },
  {
    name: '#gaana',
    username: 'Meena',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/2024_july/meena+(1).png',
  },
  {
    name: '#NEWS',
    username: 'abhasharma',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/2024_july/abhasharma.jpg',
  },
  {
    name: '#webseries',
    username: 'eshanka02',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/2024_july/eshanka02.jpeg',
  },
  // {
  //   name: '#BollyWood',
  //   username: 'jackkk',
  //   imgSrc: 'imgSrc',
  // },
  //8july
  {
    name: '#bollywood',
    username: 'poorvikanay',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/2024_july/poorvikanay+.jpg',
  },
  {
    name: '#schooldays',
    username: 'vijiwithu',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/2024_july/vijiwithu.jpeg',
  },
  {
    name: '#ShortFilm',
    username: 'ye_muxie',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/2024_july/ye_muxie.jpg',
  },
  //5july
  {
    name: '#Varsham',
    username: 'kavyajerry',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/2024_july/kavyajerry.jpeg',
  },
  {
    name: '#bestadvice',
    username: 'skytalks',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/2024_july/Skytalks.jpg',
  },
  {
    name: '#couple',
    username: 'eshanka02',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/2024_july/eshanka02.jpeg',
  },
  {
    name: '#shayaar',
    username: 'Adarsh',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/2024_july/Adarsh.jpg',
  },
  {
    name: '#RayanTata',
    username: 'abhasharma',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/2024_july/abhasharma.jpg',
  },
  //3july
  {
    name: '#Tentkotta',
    username: 'Bunnystiger',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/2024_july/Bunnystiger+mohana+priya.jpg',
  },
  {
    name: '#kalki',
    username: 'amrutaammu',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/2024_july/amrutaammu.jpeg',
  },
  {
    name: '#gaana',
    username: 'Meena',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/2024_july/meena+(1).png',
  },
  {
    name: '#movie',
    username: 'govind_sharma',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/2024_july/govind_sharma.jpg',
  },
  {
    name: '#ForeignSaruku',
    username: 'Kornana',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/2024_july/Kornana.jpg',
  },
  //1july
  {
    name: '#wildlife',
    username: 'keeruuu06',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/2024_july/keeruuu06.jpg',
  },
  {
    name: '#Trauma',
    username: 'rjkhanishka',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/2024_june/19_july1/Rj+Khanishka.jpeg',
  },
  {
    name: '#worldcup',
    username: 'riturocks',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/2024_june/19_july1/riturocks.jpg',
  },
  {
    name: '#song',
    username: 'Meena',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/2024_june/19_july1/meena+(1).png',
  },
  {
    name: '#HappyPeriods',
    username: 'amizhtha_02',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/2024_july/amizhtha_02.jpeg',
  },
  //29june
  {
    name: '#Pride',
    username: 'sathu_vocals',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/2024_june/19_july1/sathu_vocals.jpg',
  },
  {
    name: '#Poem',
    username: 'supersardarni',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/2024_june/19_july1/supersardarni.jpg',
  },
  {
    name: '#song',
    username: 'sweety96',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/2024_june/19_july1/sweety96.jpg',
  },
  {
    name: '#ptm',
    username: 'dishagowda08',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/2024_june/19_july1/dishagowda08.jpg',
  },
  //27june
  // {
  //   name: '#MUFTKIADVICE',
  //   username: 'jyotirj',
  //   imgSrc: 'imgSrc',
  // },
  {
    name: '#dedicated',
    username: 'amateur_poet',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/2024_june/19_july1/amateur_poet.jpg',
  },
  {
    name: 'name',
    username: 'RJ Shakthi',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/2024_july/shakthi.jpeg',
  },
  {
    name: '#GreenFlags',
    username: 'laxmi',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/2024_july/laxmi.jpg',
  },
  //24june
  {
    name: '#actor',
    username: 'poorvikanay',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/2024_june/19_july1/poorvikanay+.jpg',
  },
  {
    name: '#T20worldcup',
    username: 'cricketwalaladka',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/2024_june/19_july1/cricketupdate.jpg',
  },
  // {
  //   name: '#SchoolDays',
  //   username: 'pooranitalks',
  //   imgSrc: 'imgSrc',
  // },
  {
    name: '#Song',
    username: 'muffinroy',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/2024_june/19_july1/muffinroy+(2).jpg',
  },
  {
    name: '#Trip',
    username: 'sailu_the_one',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/2024_june/19_july1/sailu_the_one.jpeg',
  },
  {
    name: '#destination',
    username: 'amrutaammu',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/2024_june/19_july1/amrutaammu.jpeg',
  },
  //21june
  {
    name: '#WorldMusicday ',
    username: 'kikkuu',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/2024_june/19_july1/kikkuu.jpg',
  },
  {
    name: '#WorldMusicday',
    username: 'supersardarni',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/2024_june/19_july1/supersardarni.jpg',
  },
  {
    name: '#MyVoiceinArrè',
    username: 'purplemochi',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/2024_june/19_july1/purplemochi.jpeg',
  },
  {
    name: '#KettaPalakam',
    username: 'Bunnystiger',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/2024_july/Bunnystiger+mohana+priya.jpg',
  },
  {
    name: '#achivement',
    username: 'eshanka02',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/2024_june/19_july1/eshanka02.jpeg',
  },
  //19june
  {
    name: '#Chooseone',
    username: 'yuvideva',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/2024_june/19_july1/yuvideva.jpeg',
  },
  {
    name: '#Combo',
    username: 'kavyajerry ',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/2024_june/19_july1/Kavya.jpeg',
  },
  {
    name: '#cooking',
    username: 'deeksha05',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/2024_june/19_july1/deeksha+.jpg',
  },
  {
    name: '#feelings',
    username: 'govind_sharma',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/2024_june/19_july1/govind_sharma.jpg',
  },
  {
    name: '#alkayagnik',
    username: 'maturegirl',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/2024_june/19_july1/maturegirl.jpg',
  },
  //17june
  {
    name: '#Sentiment',
    username: 'family4',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/2024_june/17/family4.jpeg',
  },
  {
    name: '#HBDAnjali',
    username: 'shalumathu ',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/2024_june/17/Shalumathu.jpg',
  },
  {
    name: '#skincare',
    username: 'amrutaammu ',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/2024_june/17/amrutaammu.jpeg',
  },
  {
    name: '#T20worldcup',
    username: 'cricketwalaladka',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/2024_june/17/cricketupdate.jpg',
  },
  {
    name: '#T20worldcup',
    username: 'riturocks',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/2024_june/17/riturocks+copy.jpg',
  },
  //14june
  {
    name: '#neativity',
    username: 'eshanka02',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/2024_june/14/eshanka02.jpeg',
  },
  {
    name: '#ChildLabour',
    username: '_fidato',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/2024_june/14/Fidato.jpg',
  },
  {
    name: '#Pic',
    username: 'Adarsh',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/2024_june/14/Adarsh.jpeg',
  },
  {
    name: '#KuttyMe',
    username: 'ramyatalk',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/2024_june/17/Ramyatalks.jpg',
  },
  //12june
  {
    name: '#Nambikai',
    username: 'ssrilakshmi ',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/2024_june/14/ssrilakshmi.jpeg',
  },
  {
    name: '#mybirthday',
    username: 'deeksha05',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/2024_june/14/deeksha05.jpeg',
  },
  {
    name: '#Poetry',
    username: 'shyam_',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/2024_june/14/shyam_+(2).jpg',
  },
  {
    name: '#Pic',
    username: 'sailu_the_one',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/2024_june/14/sailu_the_one.jpeg',
  },
  //10june
  {
    name: '#ArreVoice',
    username: 'advii',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/2024_june/10/advii.jpeg',
  },
  {
    name: '#NoNeethulu',
    username: 'samshitaraj ',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/2024_june/10/Samshitha+.jpg',
  },
  {
    name: '#OnlyMySong',
    username: '_fidato',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/2024_june/10/Fidato.jpg',
  },
  {
    name: '#Heartbreak',
    username: 'govind_sharma',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/2024_june/10/govind_sharma.jpg',
  },
  {
    name: '#memories',
    username: 'Amrutaammu ',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/2024_june/10/amrutaammu.jpeg',
  },
  //7june
  {
    name: '#Hurting',
    username: 'rjkhanishka ',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/2024_june/10/rjkhanishka+.jpg',
  },
  {
    name: '#kannada',
    username: 'listen2vin ',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/2024_june/10/Listen2vin.jpeg',
  },
  {
    name: '#Kavidhai',
    username: 'pavithra96 ',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/2024_june/10/pavithra96.jpeg',
  },
  {
    name: '#music',
    username: 'Meena ',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/2024_june/10/meena+(1).png',
  },
  //5june
  {
    name: '#Kadhanayagan',
    username: 'vijiwithu',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/2024_june/5/vijiwithu.jpeg',
  },
  {
    name: '#Bingwatch',
    username: 'maturegirl',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/2024_june/5/maturegirl.jpeg',
  },
  {
    name: '#Baboi',
    username: 'ye_muxie',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/2024_june/5/ye_muxie.jpeg',
  },
  {
    name: '#results',
    username: 'iam_ishoo',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/2024_june/5/iam_ishoo.jpeg',
  },
  //3june
  {
    name: '#best',
    username: 'aishleshaverma',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/2024_june/5/aishleshaverma.jpeg',
  },
  {
    name: '#amusementpark',
    username: 'amrutaammu ',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/2024_june/5/amrutaammu.jpeg',
  },
  {
    name: '#Director',
    username: 'laxmi',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/2024_june/5/laxmi.jpeg',
  },
  {
    name: '#EnakuPudikum',
    username: 'shalumathu',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/2024_june/5/Shalumathu.jpeg',
  },
  //31May
  {
    name: '#Phonecalls',
    username: 'chithrasenthil',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/2024_may/31/chithrasenthil.jpeg',
  },
  {
    name: '#Best',
    username: 'chandhini_',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/2024_may/31/Chandhini+.jpg',
  },
  {
    name: '#worstdecision',
    username: 'poorvikanay ',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/2024_may/31/poorvikanay+.jpeg',
  },
  {
    name: '#Best',
    username: 'maturegirl',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/2024_may/31/maturegirl.jpeg',
  },
  {
    name: '#best',
    username: 'Lovel',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/2024_may/31/Lovel+.jpeg',
  },
  //29May
  {
    name: '#Overthinking',
    username: 'shalumathu',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/2024_may/29/Shalumathu.jpg',
  },
  {
    name: '#namooru',
    username: 'Hithaishini',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/2024_may/29/hithaishini.jpeg',
  },
  {
    name: '#IHire',
    username: 'purplemochi',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/2024_may/29/purplemochi.jpeg',
  },
  {
    name: '#gaana',
    username: 'Meena',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/2024_may/29/meena+(1)+(1).png',
  },
  {
    name: '#IHire',
    username: 'Sanav',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/2024_may/31/sanav+(1).jpg',
  },
  //27May
  {
    name: '#streetfood',
    username: 'listen2vin ',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/2024_may/27/Listen2vin.jpeg',
  },
  {
    name: '#playlist',
    username: 'sushmiii',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/2024_may/27/sushmiii.jpeg',
  },
  {
    name: '#Friend',
    username: 'sailu_the_one',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/2024_may/27/sailu_the_one.jpeg',
  },
  {
    name: '#movievsbooks',
    username: 'riturocks',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/2024_may/27/riturocks+copy.jpg',
  },
  {
    name: '#movievsbooks',
    username: 'Sanav',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/2024_may/29/sanav.jpg',
  },
  //24May
  {
    name: '#Buddha',
    username: 'govind_sharma',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/2024_may/24/govind_sharma.jpg',
  },
  {
    name: '#holidays',
    username: 'rj_jpr',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/2024_may/24/rj_jpr.png',
  },
  {
    name: '#NaPeru',
    username: 'anjubts',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/2024_may/24/anjubts.jpeg',
  },
  {
    name: '#myfears',
    username: 'eshanka02',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/2024_may/24/eshanka02.jpeg',
  },
  //22May
  {
    name: '#FindingHappiness',
    username: 'talesofharinic ',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/2024_may/22/talesofharinic.jpeg',
  },
  {
    name: '#FindingHappiness',
    username: 'deeksha05',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/2024_may/22/deeksha05.jpeg',
  },
  {
    name: '#FindingHappiness',
    username: 'family4',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/2024_may/22/family4.jpeg',
  },
  {
    name: '#TeaTime',
    username: 'Sanav',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/2024_may/22/sanav.jpg',
  },
  {
    name: '#FindingHappiness',
    username: 'jaya.life',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/2024_may/22/jayalife.jpeg',
  },
  //20May
  {
    name: '#ExamResults',
    username: 'samshitaraj ',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/2024_may/20/samshitaraj+.jpeg',
  },
  {
    name: '#ExamResults',
    username: 'saachi',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/2024_may/20/saachi.jpeg',
  },
  {
    name: '#fridayfollow',
    username: 'listen2vin ',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/2024_may/20/Listen2vin.jpeg',
  },
  {
    name: '#saturdayrelaxation',
    username: 'kavi0810',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/2024_may/20/kavi0810.jpeg',
  },
  //17May
  {
    name: '#LoveIsBlind',
    username: 'vijiwithu',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/2024_may/10/vijiwithu.jpeg',
  },
  {
    name: '#Genie',
    username: 'crisha',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/2024_may/10/crisha.jpeg',
  },
  {
    name: '#loveisblind ',
    username: 'Lovel ',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/2024_may/10/Lovel+.jpeg',
  },
  {
    name: '#wecanbefriends',
    username: 'dishagowda08',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/2024_may/10/dishagowda08.jpeg',
  },
  {
    name: '#loveisblind ',
    username: 'Adarsh',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/2024_may/10/Adarsh+(1).jpeg',
  },
  //15May
  {
    name: '#MondayMotivation',
    username: 'rjlatha',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/2024_may/10/rjlatha.png',
  },
  {
    name: '#MondayMotivation',
    username: 'monica_',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/2024_may/10/monica_.jpeg',
  },
  {
    name: '#LifeTrailer',
    username: 'Sanav',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/2024_may/10/sanav.jpg',
  },
  {
    name: '#LifeTrailer',
    username: 'abhasharma',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/2024_may/10/abhasharma.jpg',
  },
  {
    name: '#moodsofwomen',
    username: 'radhikaumesh',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/2024_may/10/radhikaumesh.jpeg',
  },
  //13May
  {
    name: '#MotherDay',
    username: 'kavyajerry ',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/2024_may/10/kavyajerry+.jpeg',
  },
  {
    name: '#MotherDay',
    username: 'archie06',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/2024_may/10/archie06+(1).jpg',
  },
  {
    name: '#MotherDay',
    username: 'Lovel ',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/2024_may/10/Lovel+.jpeg',
  },
  {
    name: '#MotherDay',
    username: 'keeruuu06',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/2024_may/10/keeruuu06.jpeg',
  },
  {
    name: '#MomsMagic',
    username: 'advii',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/2024_may/10/advii.jpeg',
  },
  //10May
  {
    name: '#ItsOkToCry',
    username: 'ye_muxie',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/2024_may/8/ye_muxie.jpeg',
  },
  {
    name: '#AnnoyingHabit',
    username: 'anuxx',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/2024_may/10/anuxx.png',
  },
  {
    name: '#imthebest',
    username: 'amrutaammu ',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/2024_may/10/amrutaammu.jpeg',
  },
  {
    name: '#ItsOkToCry',
    username: 'angell',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/2024_may/10/angell.jpg',
  },
  //8May
  {
    name: '#LifeTrailer',
    username: 'chithrasenthil',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/2024_may/8/chithu_talks.jpeg',
  },
  {
    name: '#LifeTrailer',
    username: 'Rjkhanishka ',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/2024_may/8/Rj+Khanishka.jpeg',
  },
  {
    name: '#nodietday',
    username: 'deeksha05',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/2024_may/8/deeksha05.jpeg',
  },
  {
    name: '#LifeTrailer',
    username: 'sweety96',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/2024_may/8/sweety96.jpg',
  },
  {
    name: '#LifeTrailer',
    username: 'saachi',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/2024_may/8/saachi.jpeg',
  },
  //6May
  // {
  //   name: '#moviereviewin30',
  //   username: 'jyotirj',
  //   imgSrc: 'imgSrc',
  // },
  {
    name: '#ComfortSong',
    username: 'rjharikareddy ',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/2024_may/6/rjharikareddy.jpeg',
  },
  {
    name: '#moviereviewin30',
    username: 'Sanav',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/2024_may/6/sanav.jpg',
  },
  {
    name: '#PrankCall',
    username: 'amizhtha_02',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/2024_may/6/amizhtha_02.jpeg',
  },
  {
    name: '#PrankCall',
    username: 'saachi',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/2024_may/8/saachi.jpeg',
  },
  //3May
  {
    name: '#BackToTeens',
    username: 'sailu_the_one',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/2024_may/6/sailu_the_one.jpeg',
  },
  {
    name: '#FirstDateQuestions',
    username: 'itsmefem',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/2024_may/6/itsmefem.jpeg',
  },
  {
    name: '#FirstDateQuestions',
    username: 'bindassbhawna',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/2024_may/6/bindassbhawna.jpg',
  },
  {
    name: '#FirstDateQuestions',
    username: '_fidato',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/2024_may/6/Fidato.jpg',
  },
  //1May
  {
    name: '#WorldDanceDay',
    username: 'gowthami',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/2024_may/1/gowthamigana58.jpeg',
  },
  {
    name: '#iamenough',
    username: 'maturegirl',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/2024_may/1/maturegirl.jpeg',
  },
  {
    name: '#iamenough',
    username: 'debarati ',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/2024_may/1/debarati.jpeg',
  },
  {
    name: '#NostalgiaAlert',
    username: 'pavithra96 ',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/2024_may/1/pavithra96.jpeg',
  },
  //29Apr
  {
    name: '#IfYouKnowYouKnow',
    username: 'jvln52 ',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/2024Apr/24/jvln52+.jpg',
  },
  {
    name: '#IfYouKnowYouKnow',
    username: 'govind_sharma',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/2024Apr/24/govind_sharma.jpg',
  },
  {
    name: '#IfYouKnowYouKnow',
    username: 'Sanav',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/2024_may/1/sanav.jpg',
  },
  {
    name: '#MovieReview',
    username: 'shalumathu ',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/2024_may/1/Shalumathu.jpg',
  },
  //26Apr
  {
    name: '#SummerCravings',
    username: 'laxmi',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/2024Apr/24/laxmi.jpeg',
  },
  {
    name: '#SummerCravings',
    username: 'abhasharma',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/2024Apr/24/abhasharma.jpg',
  },
  {
    name: '#SummerCravings',
    username: 'saachi',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/2024_may/1/saachi.jpeg',
  },
  {
    name: '#Boringlife',
    username: 'sushmii',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/2024_may/1/sushmiii.jpeg',
  },
  //24Apr
  {
    name: '#touchinglines',
    username: 'saachi',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/2024Apr/24/saachi.jpeg',
  },
  {
    name: '#BucketList',
    username: 'Rjkhanishka ',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/2024Apr/24/Rj+Khanishka.jpeg',
  },
  {
    name: '#BucketList',
    username: 'supersardarni',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/2024_may/1/supersardarni.jpg',
  },
  {
    name: '#FirstSalary',
    username: 'rjlatha',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/2024_may/1/rjlatha.png',
  },
  //22Apr
  {
    name: '#HomeMakerChallenges',
    username: 'saachi',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/2024Apr/22/saachi.jpeg',
  },
  {
    name: '#Lifetimefreebie',
    username: 'anuxx',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/2024_may/1/anuxx.png',
  },
  {
    name: '#HomeMakerChallenges',
    username: 'sirim',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/2024Apr/22/sirim.jpeg',
  },
  {
    name: '#HomeMakerChallenges',
    username: 'poetrybypooja',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/2024Apr/22/poetrybypooja.jpg',
  },
  //19Apr
  {
    name: '#NotAnIplFan',
    username: 'purplemochi ',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/2024Apr/17_19/purplemochi.jpeg',
  },
  {
    name: '#NotAnIplFan',
    username: 'debarati ',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/2024Apr/17_19/debarati.jpeg',
  },
  {
    name: '#JustFriends',
    username: 'pavithra96',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/2024Apr/22/pavithra96.jpeg',
  },
  //17Apr
  {
    name: '#Nayak',
    username: 'anjubts',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/2024Apr/17_19/anjubts.jpeg',
  },
  {
    name: '#Nayak',
    username: '_fidato',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/2024Apr/17_19/Fidato.jpg',
  },
  // {
  //   name: '#CHAMKILA',
  //   username: 'jyotirj',
  //   imgSrc: 'imgSrc',
  // },
  {
    name: '#nayak',
    username: 'rj_dharshu_',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/2024Apr/22/rj_dharshu_.jpeg',
  },
  //15Apr
  {
    name: '#DhoniFever',
    username: 'family4 ',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/2024Apr/15/family4+.jpeg',
  },
  {
    name: '#DhoniFever',
    username: 'sweety96',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/2024Apr/15/sweety96.jpg',
  },
  {
    name: '#ApprisalSeason',
    username: 'chithrasenthil',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/2024Apr/15/chithrasenthil.jpeg',
  },
  {
    name: '#ApprisalSeason',
    username: 'saachi',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/2024Apr/17_19/saachi.jpeg',
  },
  //12Apr
  {
    name: '#EidMubarak',
    username: 'advii',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/2024Apr/10_12/advii.jpeg',
  },
  {
    name: '#EidMubarak',
    username: 'Lovel ',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/2024Apr/10_12/Lovel+.jpeg',
  },
  {
    name: '#SummerFeels',
    username: 'divyavinni ',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/2024Apr/10_12/divyavinni+.jpeg',
  },
  {
    name: '#SummerFeels',
    username: 'shradha_sharma',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/2024Apr/10_12/shradha_sharma.jpg',
  },
  //10Apr
  {
    name: '#Collegebunking',
    username: 'sailu_the_one',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/2024Apr/10_12/sailu_the_one.jpeg',
  },
  {
    name: '#VillianEra',
    username: 'sushmii',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/2024Apr/10_12/sushmiii.jpeg',
  },
  {
    name: '#VillianEra',
    username: 'saachi',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/2024Apr/10_12/saachi.jpeg',
  },
  {
    name: '#VillianEra',
    username: 'amitskybeam',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/2024Apr/10_12/amitskybeam+(1).jpg',
  },
  //8Apr
  {
    name: '#HealthPower',
    username: 'ssrilakshmi',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/2024Apr/8/ssrilakshmi.jpeg',
  },
  {
    name: '#HealthPower',
    username: '_fidato',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/2024Apr/8/Fidato.jpg',
  },
  {
    name: '#HealthPower',
    username: 'madhu_honey',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/2024Apr/8/Madhu.jpg',
  },
  {
    name: '#CorporateLife',
    username: 'govind_sharma',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/2024Apr/8/govind_sharma.jpg',
  },
  //5Apr
  {
    name: '#oilyskin',
    username: 'saachi',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/2024Apr/8/saachi.jpeg',
  },
  {
    name: '#oilyskin',
    username: 'shalumathu',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/2024Apr/8/Shalumathu.jpg',
  },
  {
    name: '#oilyskin',
    username: 'shradha_sharma',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/2024Apr/8/shradha_sharma.jpg',
  },
  {
    name: '#Learninglanguages',
    username: 'samshitaraj',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/2024Apr/8/Samshitha+.jpg',
  },
  //3Apr
  {
    name: '#Heartbreak',
    username: 'rjlatha',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/2024Apr/3/rjlatha.png',
  },
  {
    name: '#Heartbreak',
    username: 'Rj Khanishka',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/2024Apr/3/Rj+Khanishka.jpeg',
  },
  {
    name: '#Heartbreak',
    username: 'anibha_muskan',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/2024Apr/3/anibha_muskan.png',
  },
  {
    name: '#Heartbreak',
    username: 'Lovel',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/2024Apr/3/Lavanya.jpeg',
  },
  //1Apr
  {
    name: '#aprilfools ',
    username: 'saachi',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/2024_march/29_apr_1/saachi.jpeg',
  },
  {
    name: '#aprilfools ',
    username: 'dr.sarikaverma',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/2024_march/29_apr_1/dr_sarikaverma.jpg',
  },
  {
    name: '#SpendingLimit',
    username: '.amizhtha_02',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/2024_march/29_apr_1/amizhtha_02.jpeg',
  },
  {
    name: '#WeddingEntry',
    username: 'kavyajerry ',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/2024_march/29_apr_1/Kavya.jpeg',
  },
  //29mar
  {
    name: '#KoreanCulture',
    username: 'chandhinii ',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/2024_march/29_apr_1/Chandhini+.jpg',
  },
  {
    name: '#ShockingTwist',
    username: 'pavithra96 ',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/2024_march/29_apr_1/pavithra96.jpeg',
  },
  {
    name: '#newlife',
    username: 'mrenuka',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/2024_march/29_apr_1/mrenuka+(1).jpg',
  },
  {
    name: '#newlife',
    username: 'voiceofkavi',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/2024_march/29_apr_1/voiceofkavi.png',
  },
  //27mar
  {
    name: '#RedFlagAlerts',
    username: 'swathi ',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/2024_march/27/Swathi.jpg',
  },
  {
    name: '#RedFlagAlerts',
    username: 'sweety96',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/2024_march/27/sweety96.jpg',
  },
  {
    name: '#RedFlagAlerts',
    username: 'debarati ',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/2024_march/27/debarati.jpeg',
  },
  {
    name: '#ShockingTwist',
    username: 'rjlatha',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/2024_march/27/rjlatha.png',
  },
  //25mar
  {
    name: '#SportsLovers',
    username: 'Laxmi',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/2024_march/22_25/Likitha.jpg',
  },
  {
    name: '#HOLIMEMORISE',
    username: 'Kaarav',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/2024_march/22_25/kaarav+(2).jpg',
  },
  {
    name: '#holimemories',
    username: 'Sanav',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/2024_march/22_25/sanav.jpg',
  },
  {
    name: '#LabelMe',
    username: 'fun_panromm',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/2024_march/22_25/fun_panromm.jpeg',
  },
  //22mar
  {
    name: '#plottwist',
    username: 'debarati ',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/2024_march/22_25/debarati+.jpeg',
  },
  {
    name: '#meninlove',
    username: 'family4 ',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/2024_march/22_25/family4+.jpeg',
  },
  {
    name: '#Happinessday',
    username: 'Tamizhthendral ',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/2024_march/22_25/tamizh+thendral.jpeg',
  },
  {
    name: '#mycharaCtertwin',
    username: 'Advil',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/2024_march/22_25/Advil.jpeg',
  },
  {
    name: '#Happinessday',
    username: 'abhasharma',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/2024_march/22_25/abhasharma.jpg',
  },
  //20mar
  {
    name: '#FeminineUrge',
    username: 'Rj Khanishka',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/2024_march/20/Rj+Khanishka.jpeg',
  },
  {
    name: '#FeminineUrge',
    username: 'chithu_talks',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/2024_march/20/chithu_talks.jpeg',
  },
  {
    name: '#Adulting',
    username: '_fidato',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/2024_march/20/Fidato.jpg',
  },
  {
    name: '#Adulting',
    username: 'somya',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/2024_march/20/somya+.jpg',
  },
  {
    name: '#Feminineurge',
    username: 'jyotirj',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/2024_march/20/jyotirj.jpeg',
  },
  //18mar
  {
    name: '#cultureshock ',
    username: 'saachi',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/2024_march/18/saachi.jpeg',
  },
  {
    name: '#Dreamyworld',
    username: 'rj_alaknanda',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/2024_march/18/Alaknanda.jpeg',
  },
  {
    name: '#Dreamyworld',
    username: 'abhasharma',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/2024_march/18/abhasharma.jpg',
  },
  {
    name: '#Dreamyworld',
    username: 'amizhtha_02',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/2024_march/18/amizhtha_02.jpeg',
  },
  {
    name: '#Emotional',
    username: 'drvenus',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/2024_march/18/drvenus.jpeg',
  },
  {
    name: '#Dreamyworld',
    username: 'Amrutaammu ',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/2024_march/18/amrutaammu.jpeg',
  },
  //15mar
  {
    name: '#Valuablelesson',
    username: 'samshitaraj ',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/2024_march/13_15/Samshitha+.jpg',
  },
  {
    name: '#Valuablelesson',
    username: 'Lovel ',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/2024_march/13_15/Lovel+.jpeg',
  },
  {
    name: '#Changeforgood',
    username: 'pavithra96 ',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/2024_march/13_15/pavithra96.jpeg',
  },
  {
    name: '#GuiltyPleasure',
    username: 'ambili',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/2024_march/13_15/ambili.jpeg',
  },
  {
    name: '#GuiltyPleasure',
    username: 'eshanka02',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/2024_march/13_15/eshanka02.jpeg',
  },
  {
    name: '#GuiltyPleasure',
    username: 'bindassbhawna',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/2024_march/13_15/bindassbhawna.jpg',
  },
  //13mar
  {
    name: '#MindReading',
    username: 'selfiee_divi',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/2024_march/13_15/selfiee_divi.jpeg',
  },
  {
    name: '#guiltypleasure ',
    username: 'somya ',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/2024_march/13_15/somya+.jpg',
  },
  {
    name: '#WriterInMe',
    username: 'anakhasuresh ',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/2024_march/13_15/anakhasuresh+.jpeg',
  },
  {
    name: '#pickingtraits',
    username: 'listen2vin ',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/2024_march/13_15/Listen2vin.jpeg',
  },
  {
    name: '#Difficultfoodnames',
    username: 'purplemochi ',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/2024_march/13_15/purplemochi.jpeg',
  },
  {
    name: '#Worstmentalhealthadvice',
    username: 'bindassbhawna',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/2024_march/13_15/bindassbhawna.jpg',
  },
  //11Mar
  {
    name: '#SelfAppreciation',
    username: 'shalumathu ',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/2024_march/11/Shalumathu.jpg',
  },
  {
    name: '#SelfAppreciation',
    username: 'fidato_',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/2024_march/11/Fidato.jpg',
  },
  {
    name: '#Midnightfoods',
    username: 'drvenus',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/2024_march/11/drvenus.jpeg',
  },
  {
    name: '#selfapprecition',
    username: 'Amrutaammu ',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/2024_march/11/amrutaammu.jpeg',
  },
  {
    name: '#selfapprecition',
    username: 'Lakshmi',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/2024_march/11/Lakshmi+.jpg',
  },
  {
    name: '#selfapprecition',
    username: 'jyotirj',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/2024_march/11/jyotirj.jpeg',
  },
  //8Mar
  {
    name: '#Womenwelove',
    username: 'saachi',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/2024_march/8/saachi.jpeg',
  },
  {
    name: '#Womenwelove',
    username: 'bindassbhawna',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/2024_march/8/bindassbhawna.jpg',
  },
  {
    name: '#AlternativeEnd',
    username: 'nandu__',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/2024_march/8/Nandu.jpg',
  },
  {
    name: '#BigIndianWedding',
    username: 'rjparvathy ',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/2024_march/8/rjparvathy.jpeg',
  },
  {
    name: '#BigIndianWedding',
    username: 'Subhacts ',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/2024_march/8/subhacts.jpeg',
  },
  {
    name: '#Womenwelove',
    username: 'Hithaishini ',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/2024_march/8/hithaishini.jpeg',
  },
  //6Mar
  {
    name: '#womenwelove',
    username: 'drvenus',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/2024_march/4_6/drvenus.jpeg',
  },
  {
    name: '#Perfectpartner',
    username: 'kavyajerry ',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/2024_march/4_6/kavyajerry+.jpeg',
  },
  {
    name: '#Perfectpartner',
    username: 'Lovel ',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/2024_march/4_6/Lovel+.jpeg',
  },
  {
    name: '#Womenwelove',
    username: 'thesoultalk',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/2024_march/4_6/thesoultalk+(1).jpeg',
  },
  {
    name: '#Womenwelove',
    username: 'anibha_muskan',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/2024_march/4_6/anibha_muskan.png',
  },
  {
    name: '#Perfectpartner',
    username: 'listen2vin ',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/2024_march/4_6/Listen2vin.jpeg',
  },
  //4Mar
  {
    name: '#firstborn',
    username: 'zeramary ',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/2024_march/4_6/zeramary+.jpeg',
  },
  {
    name: '#FirstBorn',
    username: 'ssrilakshmi ',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/2024_march/4_6/ssrilakshmi.jpeg',
  },
  {
    name: '#weirddreams',
    username: 'sailu_the_one',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/2024_march/4_6/sailu_the_one.jpeg',
  },
  {
    name: '#weirddreams',
    username: 'sweety96',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/2024_march/4_6/sweety96.jpg',
  },
  {
    name: '#weirddreams',
    username: 'Sanav',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/2024_march/4_6/sanav.jpg',
  },
  {
    name: '#weirddreams',
    username: 'Gunnjain',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/2024_march/4_6/gunnjain.jpeg',
  },
  //1Mar
  {
    name: '#Breakingtaboos',
    username: 'drvenus',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/2024_march/drvenus.jpeg',
  },
  {
    name: '#Leapyearbaby',
    username: 'advii',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/2024_march/advii.jpeg',
  },
  {
    name: '#Leapyearbaby',
    username: 'ssrilakshmi ',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/2024_march/ssrilakshmi.jpeg',
  },
  {
    name: '#Leapyearbaby',
    username: 'satyasri_netha',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/2024_march/taeya+(1).jpeg',
  },
  {
    name: '#Breakingtaboos',
    username: 'anjali00',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/2024_march/anjali00+(2).jpg',
  },
  {
    name: '#leapyearbaby ',
    username: 'fidato_',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/2024_march/Fidato.jpg',
  },
  //28feb
  {
    name: '#funnyemails',
    username: 'drvenus',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/feb2024/feb_28/drvenus.jpeg',
  },
  {
    name: '#funnyemails',
    username: 'saachi',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/feb2024/feb_28/saachi.jpeg',
  },
  {
    name: '#HORRIBLEFASHION',
    username: 'jyotirj',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/feb2024/feb_28/jyotirj.jpeg',
  },
  {
    name: '#CityStyles',
    username: 'chithu_talks ',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/feb2024/feb_28/chithu_talks.jpeg',
  },
  {
    name: '#Horriblefashion',
    username: 'rj_alaknanda',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/feb2024/feb_28/Alaknanda.jpeg',
  },
  {
    name: '#Horriblefashion',
    username: 'listen2vin ',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/feb2024/feb_28/Listen2vin.jpeg',
  },
  //26feb
  {
    name: '#Examstress',
    username: 'Subhacts ',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/feb2024/feb_23_26/subhacts.jpeg',
  },
  {
    name: '#PeriodComfort',
    username: 'swehar',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/feb2024/feb_23_26/swehar.jpeg',
  },
  {
    name: '#MindDump',
    username: 'voiceofkavi',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/feb2024/feb_23_26/voiceofkavi.png',
  },
  {
    name: '#MindDump',
    username: 'angell',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/feb2024/feb_23_26/angell.jpg',
  },
  {
    name: '#Travelindreams',
    username: 'divyavinni ',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/feb2024/feb_23_26/divyavinni+.jpeg',
  },
  {
    name: '#PeriodComfort',
    username: 'Amrutaammu ',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/feb2024/feb_23_26/amrutaammu.jpeg',
  },
  //23feb
  {
    name: '#nightbeforeexams',
    username: 'nanuz',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/feb2024/feb_23_26/nanuz.jpeg',
  },
  {
    name: '#funfacts',
    username: 'family4 ',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/feb2024/feb_23_26/family4+.jpeg',
  },
  {
    name: '#FunFacts',
    username: 'rjlatha',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/feb2024/feb_23_26/rjlatha.png',
  },
  {
    name: '#nightbeforexam',
    username: 'Listen2vin',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/feb2024/feb_23_26/Listen2vin.jpeg',
  },
  {
    name: '#FunFacts',
    username: 'abhasharma',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/feb2024/feb_23_26/abhasharma.jpg',
  },
  {
    name: '#funfacts ',
    username: 'somya ',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/feb2024/feb_23_26/somya+.jpg',
  },
  //21feb
  {
    name: '#Backtoschool',
    username: 'drvenus ',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/feb2024/feb_19_21/drvenus.jpeg',
  },
  {
    name: '#TeacherMatters',
    username: '_narayani',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/feb2024/feb_19_21/_narayani+(1).png',
  },
  {
    name: '#Dillogical',
    username: 'monica_',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/feb2024/feb_19_21/monica_.jpeg',
  },
  {
    name: '#Dillogical',
    username: 'Lovel ',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/feb2024/feb_19_21/Lovel+.jpeg',
  },
  {
    name: '#Backtoschool',
    username: 'amrutaammu ',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/feb2024/feb_19_21/amrutaammu.jpeg',
  },
  {
    name: '#MyCity',
    username: 'jebajustin ',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/feb2024/feb_19_21/Jeba+Justin.jpeg',
  },
  //19feb
  {
    name: '#KDramaSwap',
    username: 'hjrock',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/feb2024/feb_19_21/hjrock.jpg',
  },
  {
    name: '#DatingDrama',
    username: 'shalumathu ',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/feb2024/feb_19_21/Shalumathu.jpg',
  },
  {
    name: '#Guideme',
    username: 'nanuz',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/feb2024/feb_19_21/Nanuz.jpeg',
  },
  {
    name: '#Guideme',
    username: 'rjalakananda',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/feb2024/feb_19_21/Alaknanda.jpeg',
  },
  {
    name: '#foodie',
    username: 'harinidoddamane ',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/feb2024/feb_19_21/Harini+Kannada.jpeg',
  },
  {
    name: '#foodie',
    username: 'Sanav',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/feb2024/feb_19_21/sanav.jpg',
  },
  //15feb
  {
    name: '#radiostar',
    username: 'jyotirj',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/feb2024/feb_15/jyotirj.jpeg',
  },
  {
    name: '#kdramadreamcast',
    username: 'Harinidoddamane',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/feb2024/feb_15/Harini+Kannada.jpeg',
  },
  {
    name: '#radiostar',
    username: 'voiceofkavi',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/feb2024/feb_15/voiceofkavi.png',
  },
  {
    name: '#truelove',
    username: 'aathanamma',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/feb2024/feb_15/aathanamma.jpeg',
  },
  {
    name: '#radiostar',
    username: 'nanuz',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/feb2024/feb_15/nanuz.jpeg',
  },
  {
    name: '#Truelove',
    username: 'jvln52',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/feb2024/feb_15/Swathi.jpg',
  },
  //14feb
  {
    name: '#galentine ',
    username: 'samshitaraj',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/feb2024/feb_14/Samshitha+.jpg',
  },
  {
    name: '#galentine ',
    username: 'angell',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/feb2024/feb_14/angell.jpg',
  },
  {
    name: '#galentine ',
    username: 'Lovel ',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/feb2024/feb_14/Lovel.jpeg',
  },
  {
    name: '#valentine',
    username: 'veldeva',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/feb2024/feb_14/veldeva.jpeg',
  },
  {
    name: '#intovertlove',
    username: 'Hithaishini ',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/feb2024/feb_14/hithaishini.jpeg',
  },
  {
    name: '#valentine',
    username: 'hefzu',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/feb2024/feb_14/hefzu.jpeg',
  },
  //13feb
  {
    name: '#radioday',
    username: 'listen2vin ',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/feb2024/feb_13/Listen2vin.jpeg',
  },
  {
    name: '#poem',
    username: 'shreya_sings',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/feb2024/feb_13/shreya_sings+copy.jpg',
  },
  {
    name: '#poem',
    username: 'ssrilakshmi ',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/feb2024/feb_13/ssrilakshmi.jpeg',
  },
  {
    name: '#Galentine',
    username: 'nanuz',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/feb2024/feb_13/Nanuz.jpeg',
  },
  {
    name: '#poem',
    username: 'Sanav',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/feb2024/feb_14/sanav.jpg',
  },
  {
    name: '#radioday',
    username: 'Rj Khanishka',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/feb2024/feb_14/Rj+Khanishka.jpeg',
  },
  //12feb
  {
    name: '#justforyou',
    username: 'ambili',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/feb2024/feb_10_11_12/ambili.jpeg',
  },
  {
    name: '#popband',
    username: 'Anjubts',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/feb2024/feb_10_11_12/Anjubts.jpeg',
  },
  {
    name: '#productivity',
    username: 'jaya.life',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/feb2024/feb_10_11_12/jayalife.jpeg',
  },
  {
    name: '#JustForYou',
    username: 'maran',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/feb2024/feb_10_11_12/Maran.jpg',
  },
  {
    name: '#JustForYou',
    username: 'Amrutaammu ',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/feb2024/feb_10_11_12/amrutaammu.jpeg',
  },
  {
    name: '#JustForYou',
    username: 'saachi',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/feb2024/feb_10_11_12/saachi.jpeg',
  },
  //11feb
  {
    name: '#adayinmylife',
    username: 'jyoshnajyo ',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/feb2024/feb_10_11_12/Jyoshna+.jpg',
  },
  {
    name: '#adayinmylife',
    username: 'amizhtha_02',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/feb2024/feb_10_11_12/amizhtha_02.jpeg',
  },
  {
    name: '#adayinmylife',
    username: 'saachi',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/feb2024/feb_10_11_12/saachi.jpeg',
  },
  {
    name: '#sneakymovies',
    username: 'rjnivi',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/feb2024/feb_10_11_12/rjnivi.jpg',
  },
  {
    name: '#dayinmylife',
    username: 'drvenus ',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/feb2024/feb_10_11_12/drvenus.jpeg',
  },
  {
    name: '#dayinmylife',
    username: 'harinidoddamane ',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/feb2024/feb_10_11_12/Harini+Kannada.jpeg',
  },
  //10feb
  {
    name: '#Oscars',
    username: 'nirugowda',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/feb2024/feb_10_11_12/Nirugowda.jpeg',
  },
  {
    name: '#Oscars',
    username: 'swehar',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/feb2024/feb_10_11_12/swehar.jpeg',
  },
  {
    name: '#perfectgifts',
    username: 'Lovel ',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/feb2024/feb_10_11_12/Lovel+.jpeg',
  },
  {
    name: '#Oscars',
    username: 'smithasathish ',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/feb2024/feb_10_11_12/smithasathish.png',
  },
  {
    name: '#Oscars',
    username: 'kavyajerry ',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/feb2024/feb_10_11_12/kavyajerry+.jpeg',
  },
  {
    name: '#Oscars',
    username: 'jyotirj',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/feb2024/feb_10_11_12/jyotirj.jpeg',
  },
  //9feb
  {
    name: '#onlykpopfans',
    username: 'Amrutaammu ',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/feb2024/feb_8/amrutaammu.jpeg',
  },
  {
    name: '#fragnances',
    username: 'tamizhthendral ',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/feb2024/feb_8/tamizh+thendral.jpeg',
  },
  {
    name: '#Fragnances',
    username: 'drvenus ',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/feb2024/feb_8/drvenus.jpeg',
  },
  {
    name: '#onlykpopfans',
    username: 'pinky_lakshmi ',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/feb2024/feb_8/Lakshmi+.jpg',
  },
  {
    name: '#Fragnances',
    username: 'somya',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/feb2024/feb_10_11_12/somya+.jpg',
  },
  // {
  //   name: 'name',
  //   username: 'username',
  //   imgSrc: 'imgSrc',
  // },
  //8feb
  {
    name: '#Embarrassingmoments',
    username: 'family4 ',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/feb2024/feb_8/Pavani.jpg',
  },
  {
    name: '#FitnessTips',
    username: 'nanuz',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/feb2024/feb_8/nanuz.jpeg',
  },
  {
    name: '#FitnessTips',
    username: 'Sanav',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/feb2024/feb_10_11_12/sanav.jpg',
  },
  {
    name: '#RomanticMovies',
    username: 'aish27',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/feb2024/feb_8/Aish27.jpeg',
  },
  {
    name: '#embarrasingmoments',
    username: 'shakthi.',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/feb2024/feb_8/shakthi.jpeg',
  },
  {
    name: '#embarrasingmoments',
    username: 'bindassbhawna',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/feb2024/feb_8/bindassbhawna.jpg',
  },
  //7feb
  {
    name: '#datenight',
    username: 'Taeya_vs',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/feb2024/feb_8/taeya.jpeg',
  },
  {
    name: '#datenight',
    username: 'shalumathu',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/feb2024/feb_8/Shalumathu.jpg',
  },
  {
    name: '#datenight',
    username: 'adarshtiwari',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/feb2024/feb_8/adarshtiwari+(1).jpg',
  },
  {
    name: '#datenight',
    username: 'sushma_nagraj',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/feb2024/feb_8/sushma_nagraj.jpeg',
  },
  {
    name: '#Adulting',
    username: 'anjudas ',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/feb2024/feb_8/anjudas.png',
  },
  // {
  //   name: 'name',
  //   username: 'username',
  //   imgSrc: 'imgSrc',
  // },
  //6feb
  {
    name: '#Socialscare',
    username: 'Sailu_the_one',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/feb2024/feb_6/sailu_the_one.jpeg',
  },
  {
    name: '#NewBusiness',
    username: 'rj_dharshu_',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/feb2024/feb_6/rj_dharshu_.jpeg',
  },
  {
    name: '#Socialscare',
    username: 'kavyah',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/feb2024/feb_6/Kavyah.jpeg',
  },
  {
    name: '#Socialscare',
    username: 'medha',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/feb2024/feb_6/medha.jpeg',
  },
  {
    name: '#Socialscare',
    username: 'Amatuer',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/feb2024/feb_6/amateur_poet.jpg',
  },
  // {
  //   name: 'name',
  //   username: 'username',
  //   imgSrc: 'imgSrc',
  // },
  //5jan
  {
    name: '#Retro',
    username: 'princey ',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/feb2024/feb_5/princey+.jpeg',
  },
  {
    name: '#Adulting',
    username: 'jaya.life',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/feb2024/feb_5/jaya.jpeg',
  },
  {
    name: '#Adulting',
    username: 'somya ',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/feb2024/feb_5/somya+.jpg',
  },
  {
    name: '#Retro',
    username: 'ssrilakshmi ',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/feb2024/feb_5/ssrilakshmi.jpeg',
  },
  {
    name: '#Retro',
    username: 'listen2vin ',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/feb2024/feb_5/Listen2vin.jpeg',
  },
  {
    name: '#Retro',
    username: 'ambili',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/feb2024/feb_5/ambili.jpeg',
  },
  //4jan
  {
    name: '#PetPodTales',
    username: 'amrutaammu ',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/feb2024/feb_2_3_4/amrutaammu.jpeg',
  },
  {
    name: '#PetPodTales',
    username: 'Sanav',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/feb2024/feb_2_3_4/sanav.jpg',
  },
  {
    name: '#PetPodTales',
    username: 'adarshtiwari',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/feb2024/feb_2_3_4/adarshtiwari+(1).jpg',
  },
  {
    name: '#anxietysupport',
    username: 'drvenus ',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/feb2024/feb_2_3_4/drvenus.jpeg',
  },
  {
    name: '#anxietysupport',
    username: 'Rj Khanishka',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/feb2024/feb_2_3_4/Rj+Khanishka.jpeg',
  },
  {
    name: '#Zodiacturnoffs',
    username: 'shalumathu ',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/feb2024/feb_2_3_4/Shalumathu.jpg',
  },
  //3jan
  {
    name: '#Oldschool',
    username: 'kcdramacorner ',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/feb2024/feb_2_3_4/kcdramacorner+.jpeg',
  },
  {
    name: '#MyCareerWish',
    username: 'nanuz',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/feb2024/feb_2_3_4/nanuz.jpeg',
  },
  {
    name: '#OldSchool',
    username: 'listen2vin ',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/feb2024/feb_2_3_4/Listen2vin.jpeg',
  },
  {
    name: '#OldSchool',
    username: 'chithu_talks',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/feb2024/feb_2_3_4/chithu_talks.jpeg',
  },
  {
    name: '#OldSchool',
    username: 'fidato_',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/feb2024/feb_2_3_4/Fidato.jpg',
  },
  // {
  //   name: 'name',
  //   username: 'username',
  //   imgSrc: 'imgSrc',
  // },
  //2jan
  {
    name: '#typingmistak',
    username: 'anjali00',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/feb2024/feb_2_3_4/anjali00+(2).jpg',
  },
  {
    name: '#typingmistak',
    username: 'abhumijain ',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/feb2024/feb_2_3_4/abhumijain.jpeg',
  },
  {
    name: '#typingmistak',
    username: 'Lovel ',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/feb2024/feb_2_3_4/Lovel+.jpeg',
  },
  {
    name: '#Regender',
    username: 'jebajustin ',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/feb2024/feb_2_3_4/Jeba+Justin.jpeg',
  },
  {
    name: '#NewBites2024',
    username: 'subacts',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/feb2024/feb_2_3_4/subhacts.jpeg',
  },
  {
    name: '#NewBites2024',
    username: 'madhu_honey',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/feb2024/feb_2_3_4/Madhu.jpg',
  },
  //1feb
  {
    name: '#Onlinefriend',
    username: 'purplemochi',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/feb2024/feb_1/purplemochi.jpeg',
  },
  {
    name: '#Transport',
    username: 'sweety96',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/feb2024/feb_1/sweety96.jpg',
  },
  {
    name: '#Onlinefriend',
    username: 'fidato_',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/feb2024/feb_1/Fidato.jpg',
  },
  {
    name: '#Transport',
    username: 'amrutaammu ',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/feb2024/feb_1/amrutaammu.jpeg',
  },
  {
    name: '#Transport',
    username: 'sruthisreedhar ',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/feb2024/feb_1/sruthisreedhar.jpg',
  },
  {
    name: '#OnlineFriend',
    username: 'rituminnie ',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/feb2024/feb_1/rituminnie.jpeg',
  },
  //31jan
  {
    name: '#innerpoet',
    username: 'pinky_lakshmi',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/jan2024/jan_31/Lakshmi+.jpg',
  },
  {
    name: '#unbelievable',
    username: 'pavithara',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/jan2024/jan_31/pavithara.jpeg',
  },
  {
    name: '#FirstMonth',
    username: 'subhacts',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/jan2024/jan_31/subhacts.jpeg',
  },
  {
    name: '#FirstMonth',
    username: 'abhumijain ',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/jan2024/jan_31/abhumijain.jpeg',
  },
  {
    name: '#FirstMonth',
    username: 'bindassbhawna',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/jan2024/jan_31/bindassbhawna.jpg',
  },
  // {
  //   name: 'name',
  //   username: 'username',
  //   imgSrc: 'imgSrc',
  // },
  //30 jan
  {
    name: '#Introvert',
    username: 'Divyavinni ',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/jan2024/jan_30/Divya.jpg',
  },
  {
    name: '#Concerttime',
    username: 'Kavyah',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/jan2024/jan_30/Kavyah.jpeg',
  },
  {
    name: '#Introvert',
    username: 'drvenus',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/jan2024/jan_30/drvenus.jpeg',
  },
  {
    name: '#Introvert',
    username: 'lavu091',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/jan2024/jan_30/Lavanya.jpeg',
  },
  {
    name: '#Introvert',
    username: 'riturocks',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/jan2024/jan_30/riturocks+copy.jpg',
  },
  {
    name: '#MyPlaylist',
    username: 'amrutaammu ',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/jan2024/jan_30/amrutaammu.jpeg',
  },
  //29jan
  {
    name: '#MovieMarathon',
    username: '4hanna',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/jan2024/jan_29/4hanna+-+Aneesa.jpeg',
  },
  {
    name: '#MovieMarathon',
    username: 'rjlatha',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/jan2024/jan_29/rjlatha.png',
  },
  {
    name: '#Secure',
    username: 'harinidoddamane ',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/jan2024/jan_29/Harini+Kannada.jpeg',
  },
  {
    name: '#Secure',
    username: 'sailu_the_one',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/jan2024/jan_29/sailu_the_one.jpeg',
  },
  {
    name: '#secure ',
    username: 'fidato_',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/jan2024/jan_30/Fidato.jpg',
  },
  {
    name: ' #Concerttime',
    username: 'jyotirj',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/jan2024/jan_30/jyotirj.jpeg',
  },
  //28jan
  {
    name: '#Slangs',
    username: 'amizhtha_02',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/jan2024/jan_25_26_27_28/amizhtha_02.jpeg',
  },
  {
    name: '#FlirtGame',
    username: 'amrutaammu ',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/jan2024/jan_25_26_27_28/amrutaammu.jpeg',
  },
  {
    name: '#Selflove',
    username: 'drvenus',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/jan2024/jan_25_26_27_28/drvenus.jpeg',
  },
  {
    name: '#FlirtGame',
    username: 'anjali00',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/jan2024/jan_25_26_27_28/anjali00+(2).jpg',
  },
  {
    name: '#Selflove',
    username: 'voiceofkavi',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/jan2024/jan_25_26_27_28/voiceofkavi.png',
  },
  {
    name: '#Slangs',
    username: 'monica_',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/jan2024/jan_25_26_27_28/monica_.jpeg',
  },
  //27jan
  {
    name: '#calmdown',
    username: 'poeticlocker',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/jan2024/jan_25_26_27_28/poeticlocker.jpg',
  },
  {
    name: '#calmdown',
    username: 'subhacts',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/jan2024/jan_25_26_27_28/subhacts.jpeg',
  },
  {
    name: '#InTheBag',
    username: 'listen2vin',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/jan2024/jan_25_26_27_28/Listen2vin.jpeg',
  },
  {
    name: '#InTheBag',
    username: 'shalumathu',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/jan2024/jan_25_26_27_28/Shalumathu.jpg',
  },
  {
    name: '#InTheBag',
    username: 'Sanav',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/jan2024/jan_25_26_27_28/sanav.jpg',
  },
  {
    name: '#Memories',
    username: 'rjalakananda',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/jan2024/jan_25_26_27_28/Alaknanda.jpeg',
  },
  //26jan
  {
    name: '#WeekendPlans',
    username: 'lakshmidinesh ',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/jan2024/jan_25_26_27_28/Lakshmidinesh+.jpg',
  },
  {
    name: '#RepublicDay',
    username: 'sushma_nagraj',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/jan2024/jan_25_26_27_28/sushma_nagraj.jpeg',
  },
  {
    name: '#Schooldays',
    username: 'family4',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/jan2024/jan_25_26_27_28/family4.jpeg',
  },
  {
    name: '#RepublicDay',
    username: 'anibha_muskan',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/jan2024/jan_29/anibha_muskan.png',
  },
  {
    name: '#RepublicDay',
    username: 'lavu091',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/jan2024/jan_25_26_27_28/Lavanya.jpeg',
  },
  {
    name: '#RepublicDay',
    username: 'drvenus',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/jan2024/jan_25_26_27_28/drvenus.jpeg',
  },
  //25jan
  {
    name: '#onlymycity',
    username: 'princey',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/jan2024/jan_25_26_27_28/princey.jpeg',
  },
  {
    name: '#onlygoodvibes',
    username: 'kikkuu',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/jan2024/jan_25_26_27_28/kikkuu.jpg',
  },
  {
    name: '#CryingLoudly',
    username: 'skipsway',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/jan2024/jan_25_26_27_28/skipsway.jpeg',
  },
  {
    name: '#Cryingoutloudly',
    username: 'vjpriya',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/jan2024/jan_25_26_27_28/vjpriya.png',
  },
  {
    name: '#Rumours',
    username: 'Amrutaammu',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/jan2024/jan_25_26_27_28/amrutaammu.jpeg',
  },
  {
    name: '#Rumours',
    username: 'fidato_',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/jan2024/jan_25_26_27_28/Fidato.jpg',
  },
  //24jan
  {
    name: '#Friendinneed',
    username: 'lavu091',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/jan2024/jan_24/Lavanya.jpeg',
  },
  {
    name: '#Friendinneed',
    username: 'rjnivi',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/jan2024/jan_24/rjnivi.jpg',
  },
  {
    name: '#Friendinneed',
    username: 'madhu_honey',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/jan2024/jan_24/Madhu.jpg',
  },
  {
    name: '#Favdish',
    username: 'jebajustin ',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/jan2024/jan_25_26_27_28/Jeba+Justin.jpeg',
  },
  {
    name: '#Favdish',
    username: 'subhacts',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/jan2024/jan_24/subhacts.jpeg',
  },
  {
    name: '#Favdish',
    username: 'harinidoddamane ',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/jan2024/jan_25_26_27_28/Harini+Kannada.jpeg',
  },
  //23jan
  {
    name: '#Powercouple',
    username: 'kavyajerry ',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/jan2024/jan_23/Kavya.jpeg',
  },
  {
    name: '#Comfy',
    username: 'rjtamil',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/jan2024/jan_23/Rjtamil.jpg',
  },
  {
    name: '#Comfy',
    username: 'nirugowda ',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/jan2024/jan_23/Nirugowda.jpeg',
  },
  {
    name: '#Comfy',
    username: 'bindassbhawna',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/jan2024/jan_23/bindassbhawna.jpg',
  },
  {
    name: '#Comfy',
    username: 'voiceofkavi',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/jan2024/jan_23/voiceofkavi.png',
  },
  {
    name: '#Comfy',
    username: '4hanna',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/jan2024/jan_24/4hanna+-+Aneesa.jpeg',
  },
  //22jan
  {
    name: '#oops',
    username: 'kcdramacorner ',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/jan2024/jan_21_22/kcdramacorner+.jpeg',
  },
  {
    name: '#skincare',
    username: 'rjpriya',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/jan2024/jan_21_22/rjpriya.jpeg',
  },
  {
    name: '#skincare',
    username: 'hjrock',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/jan2024/jan_21_22/hjrock.jpg',
  },
  {
    name: '#skincare',
    username: 'lavu091',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/jan2024/jan_21_22/lavu091.jpeg',
  },
  {
    name: '#Starwedding',
    username: 'sruthisreedhar',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/jan2024/jan_21_22/sruthisreedhar.jpg',
  },
  {
    name: '#StarWedding',
    username: 'harinidoddamane ',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/jan2024/jan_23/Harini+Kannada.jpeg',
  },
  //21jan
  {
    name: '#Guessthesong',
    username: 'pinky_lakshmi',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/jan2024/jan_21_22/Lakshmi+.jpg',
  },
  {
    name: '#Guessthesong',
    username: 'drvenus',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/jan2024/jan_21_22/drvenus.jpeg',
  },
  {
    name: '#Guessthesong',
    username: 'fidato_',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/jan2024/jan_21_22/Fidato.jpg',
  },
  {
    name: '#Guessthesong',
    username: 'abhasharma',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/jan2024/jan_21_22/abhasharma.jpg',
  },
  {
    name: '#Guessthesong',
    username: 'wominspire ',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/jan2024/jan_21_22/wominspire.jpeg',
  },
  {
    name: '#Guessthesong',
    username: 'listen2vin',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/jan2024/jan_21_22/Listen2vin.jpeg',
  },
  //20jan
  {
    name: '#MoodKiller ',
    username: 'medha',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/jan2024/jan_18_19_20/medha.jpeg',
  },
  {
    name: '#MyGreenFlag',
    username: 'Madhu01_31',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/jan2024/jan_18_19_20/Madhu01_31.jpg',
  },
  {
    name: '#MyGreenFlag',
    username: 'Sanav',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/jan2024/jan_21_22/sanav.jpg',
  },
  {
    name: '#MyGreenFlag',
    username: 'sweety96',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/jan2024/jan_18_19_20/sweety96.jpg',
  },
  {
    name: '#MyCity',
    username: 'selfiee_divi',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/jan2024/jan_21_22/selfiee_divi.jpeg',
  },
  {
    name: '#Mygreenflag',
    username: 'sushma_nagraj',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/jan2024/jan_21_22/sushma_nagraj.jpeg',
  },
  //19jan
  {
    name: '#TitleSongs',
    username: 'sailu_the_one',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/jan2024/jan_18_19_20/Sailu.jpeg',
  },
  {
    name: '#TitleSongs',
    username: 'sneha_singss',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/jan2024/jan_18_19_20/sneha_singss.jpg',
  },
  {
    name: '#TitleSongs',
    username: 'somya',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/jan2024/jan_21_22/somya+.jpg',
  },
  {
    name: '#TitleSongs',
    username: 'drvenus',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/jan2024/jan_18_19_20/drvenus.jpeg',
  },
  {
    name: '#waitwhy',
    username: 'deepavelu',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/jan2024/jan_21_22/Deepavelu.jpeg',
  },
  {
    name: '#Titlesongs',
    username: 'amrutaammu',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/jan2024/jan_21_22/amrutaammu.jpeg',
  },
  //18jan
  {
    name: '#SelfLove',
    username: 'harinidoddamane ',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/jan2024/jan_18_19_20/Harini+Kannada.jpeg',
  },
  {
    name: '#SelfHelp',
    username: 'hi_himawari',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/jan2024/jan_18_19_20/hi_himawari.jpeg',
  },
  // {
  //   name: 'name',
  //   username: 'username',
  //   imgSrc: 'imgSrc',
  // },
  {
    name: '#SelfHelp',
    username: 'subhacts',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/jan2024/jan_18_19_20/subhacts.jpeg',
  },
  {
    name: '#SelfHelp',
    username: 'pavithra96',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/jan2024/jan_21_22/pavithra96.jpeg',
  },
  {
    name: '#Selflove',
    username: 'Amatuer',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/jan2024/jan_18_19_20/amateur_poet.jpg',
  },
  //17jan
  {
    name: '#Badgifts',
    username: 'rjpriya',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/jan2024/jan_17/rjpriya.jpeg',
  },
  {
    name: '#Badgifts',
    username: 'nimmy',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/jan2024/jan_17/nimmy.jpeg',
  },
  {
    name: '#Badgifts',
    username: 'jyotirj',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/jan2024/jan_17/jyotirj.jpeg',
  },
  {
    name: '#Badgifts',
    username: 'princey',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/jan2024/jan_17/princey.jpeg',
  },
  {
    name: '#Badgifts',
    username: 'listen2vin ',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/jan2024/jan_18_19_20/Listen2vin.jpeg',
  },
  {
    name: '#Badgifts',
    username: 'lavu091',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/jan2024/jan_18_19_20/Lavanya.jpeg',
  },
  //16jan
  {
    name: '#dilse',
    username: 'ssrilakshmi ',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/jan2024/jan_16/ssrilakshmi.jpeg',
  },
  {
    name: '#TVshows',
    username: '4hanna',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/jan2024/jan_16/4hanna+-+Aneesa.jpeg',
  },
  {
    name: '#TVshows',
    username: 'amrutaammu ',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/jan2024/jan_16/amrutaammu.jpeg',
  },
  {
    name: '#Dilse ',
    username: 'shiv_0510',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/jan2024/jan_16/shiv_0510.jpg',
  },
  {
    name: '#TVshows',
    username: 'Sanav',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/jan2024/jan_16/sanav.jpg',
  },
  {
    name: '#FestivalRecipes',
    username: 'rj_alaknanda',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/jan2024/jan_16/Alaknanda.jpeg',
  },
  //15jan
  {
    name: '#safespace',
    username: 'anjudas',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/jan2024/jan_15/anjudas.png',
  },
  {
    name: '#Pongal',
    username: 'maran',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/jan2024/jan_15/Maran.jpg',
  },
  {
    name: '#Favpatner',
    username: 'riturocks',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/jan2024/jan_15/riturocks+copy.jpg',
  },
  {
    name: '#Pongal',
    username: 'sushma_nagraj',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/jan2024/jan_15/sushma_nagraj.jpeg',
  },
  {
    name: '#Favpatner',
    username: 'somya ',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/jan2024/jan_16/somya+.jpeg',
  },
  {
    name: '#Guesswhat',
    username: 'divyavinni',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/jan2024/jan_16/Divya.jpg',
  },
  //14jan
  {
    name: '#Dreamconcert',
    username: 'aleenanavaneeth ',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/jan2024/jan_14/aleenanavaneeth+.jpg',
  },
  {
    name: '#stupidlove',
    username: 'shalumathu',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/jan2024/jan_14/Shalumathu.jpg',
  },
  {
    name: '#DreamConcert',
    username: 'aish27',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/jan2024/jan_15/Aish27.jpeg',
  },
  {
    name: '#stupidlove',
    username: 'Amatuer',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/jan2024/jan_14/amateur_poet.jpg',
  },
  {
    name: '#stupidlove',
    username: 'Anukoya',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/jan2024/jan_14/Anukoya.jpeg',
  },
  // {
  //   name: 'name',
  //   username: 'fidato_',
  //   imgSrc: 'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/jan2024/jan_14/Fidato.jpg',
  // },
  //13jan
  {
    name: '#SerialReader',
    username: 'hefzi ',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/jan2024/jan_12/hefzi+.jpeg',
  },
  {
    name: ' #Bffs',
    username: 'purplemochi',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/jan2024/jan_12/purplemochi.jpeg',
  },
  {
    name: ' #Bffs',
    username: 'shagungarg',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/jan2024/jan_12/shagungarg.jpg',
  },
  {
    name: '#Bffs',
    username: 'rjpriya',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/jan2024/jan_12/rjpriya.jpeg',
  },
  {
    name: '#AccentGame',
    username: 'amrutaammu ',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/jan2024/jan_12/amrutaammu.jpeg',
  },
  // {
  //   name: 'name',
  //   username: 'username',
  //   imgSrc: 'imgSrc',
  // },
  //12jan
  {
    name: '#Heartbreak',
    username: 'medha',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/jan2024/jan_12/medha.jpeg',
  },
  {
    name: '#korea',
    username: 'Jyoshna',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/jan2024/jan_12/Jyoshna+.jpg',
  },
  {
    name: '#Heartbreak',
    username: 'jyotirj',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/jan2024/jan_12/jyotirj.jpeg',
  },
  {
    name: '#Heartbreak',
    username: 'voiceofpreethi',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/jan2024/jan_12/Preethi.jpg',
  },
  {
    name: '#korea',
    username: 'harinidoddamane',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/jan2024/jan_12/Harini+Kannada.jpeg',
  },
  // {
  //   name: 'name',
  //   username: 'username',
  //   imgSrc: 'imgSrc',
  // },
  //11jan
  {
    name: '#BadTeacher ',
    username: 'jvln52 ',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/jan2024/jan_11/Swathi.jpg',
  },
  {
    name: '#Badteacher ',
    username: 'subhacts',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/jan2024/jan_11/subhacts.jpeg',
  },
  {
    name: '#Badteacher ',
    username: 'riturocks',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/jan2024/jan_11/riturocks+copy.jpg',
  },
  {
    name: '#MoneyTalks',
    username: 'lakshmidinesh',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/jan2024/jan_11/Lakshmidinesh+.jpg',
  },
  {
    name: '#BadTeacher',
    username: 'nirugowda ',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/jan2024/jan_11/Nirugowda.jpeg',
  },
  {
    name: '#BadTeacher',
    username: 'Dhanyasher ',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/jan2024/jan_11/dhanyaasher.jpeg',
  },
  //10jan
  {
    name: '#Firsts',
    username: 'rjkhanishka ',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/jan2024/jan_10/Rj+Khanishka.jpeg',
  },
  {
    name: '#Firsts',
    username: 'voizof_sakhi',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/jan2024/jan_10/voizof_sakhi.jpeg',
  },
  {
    name: '#Thirdwheel',
    username: 'sukirtigupta',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/jan2024/jan_10/sukirtigupta.jpg',
  },
  {
    name: '#Firsts',
    username: 'listen2vin ',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/jan2024/jan_10/Listen2vin.jpeg',
  },
  {
    name: '#LoveTalk',
    username: 'rjtamil',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/jan2024/jan_10/Rjtamil.jpg',
  },
  {
    name: '#Firsts',
    username: 'fidato_',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/jan2024/jan_10/Fidato.jpg',
  },
  //9jan
  {
    name: '#Talks',
    username: 'anakhasuresh',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/jan2024/jan_9/anakhasuresh.jpeg',
  },
  {
    name: '#Dayout',
    username: 'family4',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/jan2024/jan_9/family4.jpeg',
  },
  {
    name: '#Dayout',
    username: 'pavithra96',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/jan2024/jan_9/pavithra96.jpeg',
  },
  {
    name: '#Talks',
    username: 'aish27',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/jan2024/jan_9/Aish27.jpeg',
  },
  {
    name: '#Talks',
    username: 'aishleshaverma',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/jan2024/jan_9/aishleshaverma.jpg',
  },
  // {
  //   name: 'name',
  //   username: 'username',
  //   imgSrc: 'imgSrc',
  // },
  //8jan
  {
    name: '#Skincare',
    username: 'fidato_',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/jan2024/jan_8/Fidato+(1).jpg',
  },
  {
    name: '#Parenting',
    username: 'chithu_talks',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/jan2024/jan_8/chithu_talks.jpeg',
  },
  {
    name: '#Parenting',
    username: 'pinky_lakshmi',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/jan2024/jan_8/pinky_lakshmi+.jpeg',
  },
  {
    name: '#Parenting',
    username: 'smithasathish',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/jan2024/jan_8/smithasathish.png',
  },
  {
    name: '#Parenting',
    username: 'jyotirj',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/jan2024/jan_8/jyotirj.jpeg',
  },
  {
    name: '#Parenting',
    username: 'Dhanyasher',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/jan2024/jan_8/dhanyaasher.jpeg',
  },
  //7jan
  {
    name: '#InLaws',
    username: 'sunithazz',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/jan2024/jan_5_6_7/Sunitha.jpg',
  },
  {
    name: '#ComfortMovies',
    username: 'zeramary ',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/jan2024/jan_5_6_7/zeramary+.jpeg',
  },
  {
    name: '#ComfortMovies ',
    username: 'sweety96',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/jan2024/jan_5_6_7/sweety96.jpg',
  },
  {
    name: '#InLaws',
    username: 'rj_diya07',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/jan2024/jan_5_6_7/RJ+Diya.png',
  },
  {
    name: '#InLaws',
    username: 'listen2vin ',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/jan2024/jan_5_6_7/Listen2vin.jpeg',
  },
  {
    name: '#ComfortMovies ',
    username: 'fidato_',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/jan2024/jan_5_6_7/Fidato.jpg',
  },
  //6jan
  {
    name: '#ARRahmanhits',
    username: 'Taeya_va',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/jan2024/jan_5_6_7/taeya.jpeg',
  },
  {
    name: '#ARRahmanHits',
    username: 'ambili',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/jan2024/jan_5_6_7/ambili.jpeg',
  },
  {
    name: '#90sFashion',
    username: 'satbhagya',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/jan2024/jan_5_6_7/satbhagya.png',
  },
  {
    name: '#90sFashion',
    username: 'harinidoddamane',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/jan2024/jan_5_6_7/HariniKannada.jpeg',
  },
  {
    name: '#90sFashion',
    username: 'Sanav',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/jan2024/jan_5_6_7/sanav.jpg',
  },
  {
    name: '#90sFashion',
    username: 'nivili',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/jan2024/jan_5_6_7/nivili.jpeg',
  },
  //5jan
  {
    name: '#FilmyTalk',
    username: 'moonkim',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/jan2024/jan_5_6_7/moonkim.jpg',
  },
  {
    name: '#Foodie',
    username: 'medha',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/jan2024/jan_5_6_7/medha.jpeg',
  },
  {
    name: '#ArrangedMarriages',
    username: 'Dhivyam',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/jan2024/jan_5_6_7/dhivyam.jpeg',
  },
  {
    name: '#Foodie',
    username: 'abhumijain',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/jan2024/jan_5_6_7/abhumijain.jpeg',
  },
  {
    name: '#Foodie',
    username: 'riturocks',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/jan2024/jan_5_6_7/riturocks+copy.jpg',
  },
  // {
  //   name: 'name',
  //   username: 'username',
  //   imgSrc: 'imgSrc',
  // },
  //4jan
  {
    name: '#Dreambig',
    username: 'sindhu_62',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/jan2024/jan_4/Sindhu+.jpg',
  },
  {
    name: '#Extalks',
    username: 'rj_vaseema',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/jan2024/jan_4/rj_vaseema.jpeg',
  },
  {
    name: '#Extalks',
    username: 'ambili',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/jan2024/jan_4/ambili.jpeg',
  },
  {
    name: '#DreamBig',
    username: 'harinidoddamane ',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/jan2024/jan_4/Harini+Kannada.jpeg',
  },
  {
    name: '#Extalks',
    username: 'voiceofkavi',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/jan2024/jan_4/voiceofkavi.png',
  },
  {
    name: '#DreamBig',
    username: 'lavu091',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/jan2024/jan_4/Lavanya.jpeg',
  },
  //3jan
  {
    name: '#2024',
    username: 'kavyajerry',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/jan2024/jan_3/Kavya.jpeg',
  },
  {
    name: '#2024',
    username: 'MS_Pramila069',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/jan2024/jan_3/MS_Pramila069.jpeg',
  },
  {
    name: '#WinterSpecial',
    username: 'soybee',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/jan2024/jan_3/soybee.jpeg',
  },
  {
    name: '#WinterSpecial',
    username: 'smithasathish',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/jan2024/jan_3/smithasathish.png',
  },
  {
    name: '#WinterSpecial',
    username: 'aishleshaverma',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/jan2024/jan_3/aishleshaverma.jpg',
  },
  {
    name: '#WinterSpecial',
    username: 'Sanav',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/jan2024/jan_3/sanav.jpg',
  },
  //2jan
  {
    name: '#Superstitions',
    username: 'itsmefem',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/jan2024/jan_2/itsmefem.jpeg',
  },
  {
    name: '#2024predictions',
    username: 'madhu_honey',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/jan2024/jan_2/Madhu.jpg',
  },
  {
    name: '#Wisdom ',
    username: 'kiranbala ',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/jan2024/jan_2/kiranbala.jpeg',
  },
  {
    name: '#Wisdom ',
    username: 'sakshijimehra',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/jan2024/jan_2/sakshijimehra.jpg',
  },
  {
    name: '#Wisdom ',
    username: 'lavu091',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/jan2024/jan_2/Lavanya.jpeg',
  },
  {
    name: '#2024predictions',
    username: 'amrutaammu ',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/jan2024/jan_2/amrutaammu.jpeg',
  },
  //1jan
  {
    name: '#MovieTalk',
    username: 'zeramary',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/jan2024/jan_1/zeramary+.jpeg',
  },
  {
    name: '#newyearnewme',
    username: 'fidato_',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/jan2024/jan_1/Fidato.jpg',
  },
  {
    name: '#newyearnewme',
    username: 'thamizhthendral',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/jan2024/jan_1/_tamizh+thendral.jpeg',
  },
  {
    name: '#Lastnightplans',
    username: 'Kalyani3000',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/jan2024/jan_1/Kalyani.jpg',
  },
  {
    name: '#Lastnightplans',
    username: 'anjali00',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/jan2024/jan_1/anjali00+(1).jpg',
  },
  {
    name: '#Lastnightplans',
    username: 'aish27',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/jan2024/jan_1/Aish27.jpeg',
  },
  //31dec
  {
    name: '#Happynewyear',
    username: 'princey',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/dec_29_30_31/princey.jpeg',
  },
  {
    name: '#FavouritePerson',
    username: 'drvenus',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/dec_29_30_31/drvenus.jpeg',
  },
  {
    name: '#FavouritePerson',
    username: 'voiceofkavi',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/dec_29_30_31/voiceofkavi.png',
  },
  {
    name: '#Happynewyear',
    username: 'jyotirj',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/dec_29_30_31/jyotirj.jpeg',
  },
  {
    name: '#FavouritePerson',
    username: 'abhumijain',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/dec_29_30_31/abhumijain.jpeg',
  },
  {
    name: '#FavouritePerson',
    username: 'pavithra96',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/dec_29_30_31/pavithra96.jpeg',
  },
  //30dec
  {
    name: '#Stereotypes',
    username: 'nanuz',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/dec_29_30_31/nanuz.jpeg',
  },
  {
    name: '#Stereotypes',
    username: 'hi_himawari',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/dec_29_30_31/hi_himawari+.jpeg',
  },
  {
    name: '#Stereotypes',
    username: 'deekshu_',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/dec_29_30_31/Deekshu.jpg',
  },
  {
    name: '#Stereotypes',
    username: 'swehar',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/dec_29_30_31/swehar.jpeg',
  },
  {
    name: '#Stereotypes',
    username: 'aishleshaverma',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/dec_29_30_31/aishleshaverma.jpg',
  },
  {
    name: '#Stereotypes',
    username: 'lavu091',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/dec_29_30_31/Lavanya.jpeg',
  },
  //29dec
  {
    name: '#Foodie',
    username: 'sruthisreedhar',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/dec_29_30_31/sruthisreedhar++(1).jpeg',
  },
  {
    name: '#MusicalLife',
    username: 'rj_alakananda',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/dec_29_30_31/rj_alakananda.jpeg',
  },
  {
    name: '#MusicalLife',
    username: 'pavithra96',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/dec_29_30_31/pavithra96.jpeg',
  },
  {
    name: '#Travelsplans',
    username: 'aishleshaverma',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/dec_29_30_31/aishleshaverma.jpg',
  },
  {
    name: '#TravelPlans',
    username: 'harinidoddamane',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/dec_29_30_31/Harini+Kannada.jpeg',
  },
  {
    name: '#TravelPlans',
    username: 'Sanav',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/dec_29_30_31/sanav.jpg',
  },
  //28dec
  {
    name: '#PeopleOf2023',
    username: 'listen2vin ',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/dec_28/Listen2vin.jpeg',
  },
  {
    name: '#Balance',
    username: 'anjudas',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/dec_28/anjudas.png',
  },
  {
    name: '#Balance',
    username: 'sailu_the_one',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/dec_28/_sailu_the_one.jpg',
  },
  {
    name: '#PeopleOf2023',
    username: 'lavu091',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/dec_28/Lavanya.jpeg',
  },
  {
    name: '#Balance',
    username: 'cheeku_661',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/dec_28/cheeku_661+(1).jpeg',
  },
  {
    name: '#Peopleof2023',
    username: 'vijuwithu',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/dec_28/vijiwithu.jpeg',
  },
  //27dec
  {
    name: '#TravelDiaries',
    username: 'smithasathish',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/dec_27/smithasathish.png',
  },
  {
    name: '#SelfLove',
    username: 'shiny7',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/dec_27/Saranya+.jpg',
  },
  {
    name: '#TravelDiaries',
    username: 'bindassbhawna',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/dec_27/bindassbhawna.jpg',
  },
  {
    name: '#SelfLove',
    username: 'Sanav',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/dec_27/sanav.jpg',
  },
  {
    name: '#TravelDiaries',
    username: 'amrutaammu ',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/dec_27/amrutaammu.jpeg',
  },
  {
    name: '#SelfLove',
    username: 'reenaammu',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/dec_27/reenaammu.jpeg',
  },
  //26dec
  {
    name: '#rant',
    username: 'justveraa ',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/dec_26/Veraa.jpeg',
  },
  {
    name: '#rant',
    username: 'abhumijain ',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/dec_26/abhumijain.jpeg',
  },
  {
    name: '#LifeLessons',
    username: 'drama_purple',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/dec_26/drama_purple.jpg',
  },
  {
    name: '#LifeLessons',
    username: 'laxmi',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/dec_26/Likitha.jpg',
  },
  {
    name: '#TimeTravel',
    username: 'neenutins2017 ',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/dec_26/neenutins2017+.jpeg',
  },
  {
    name: '#TimeTravel',
    username: 'sweety96',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/dec_26/sweety96.jpg',
  },
  //25dec
  {
    name: '#Santa',
    username: 'Kavyah',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/dec_26/Kavyah.jpeg',
  },
  {
    name: '#movietalk',
    username: 'arushisvoice',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/dec_25/arushisvoice.jpg',
  },
  {
    name: '#Santa',
    username: 'amrutaammu',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/dec_25/amrutaammu.jpeg',
  },
  {
    name: '#Santa',
    username: 'skipsway',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/dec_25/skipsway.jpeg',
  },
  {
    name: '#LifeStory',
    username: 'divyavinni',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/dec_25/Divya.jpg',
  },
  {
    name: '#movietalk',
    username: 'lavu091',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/dec_25/Lavanya.jpeg',
  },
  //24dec
  {
    name: '#Hiddengem',
    username: 'sweety96',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/dec_22_23_24/sweety96.jpg',
  },
  {
    name: '#HiddenGems',
    username: 'drvenus',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/dec_22_23_24/drvenus.jpeg',
  },
  {
    name: '#Movietalk',
    username: 'jvln52',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/dec_22_23_24/jvln52.jpeg',
  },
  {
    name: '#HiddenGems',
    username: 'Harinidoddamane',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/dec_22_23_24/Harini+Kannada.jpeg',
  },
  {
    name: '#2023recap',
    username: 'rjpriya',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/dec_22_23_24/rjpriya.jpeg',
  },
  {
    name: '#2023recap',
    username: 'lavu091',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/dec_22_23_24/Lavanya.jpeg',
  },
  //23dec
  {
    name: '#bookworm',
    username: 'madhu_honey',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/dec_22_23_24/Madhu.jpg',
  },
  {
    name: '#2023recap',
    username: 'nirugowda',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/dec_22_23_24/Nirugowda.jpeg',
  },
  {
    name: '#santa',
    username: 'nanuz',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/dec_22_23_24/nanuz.jpeg',
  },
  {
    name: '#2023recap',
    username: 'shreya_sings',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/dec_22_23_24/shreya_sings+copy.jpg',
  },
  {
    name: '#2023recap',
    username: 'palanikani',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/dec_22_23_24/palanikani.jpeg',
  },
  {
    name: '#2023recap',
    username: 'voiceofkavi',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/dec_22_23_24/voiceofkavi.png',
  },
  //22dec
  {
    name: '#Rapper',
    username: 'purplemochi',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/dec_22_23_24/purplemochi.jpeg',
  },
  {
    name: '#lovetalk',
    username: '4hanna',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/dec_22_23_24/4hanna+-+Aneesa.jpeg',
  },
  {
    name: '#Rapper',
    username: 'aish27',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/dec_22_23_24/Aish27.jpeg',
  },
  {
    name: '#Rapper',
    username: 'bhuvanaprabhu',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/dec_22_23_24/Bhuvana+Prabhu.jpeg',
  },
  {
    name: '#Rapper',
    username: 'voiceofkavi',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/dec_22_23_24/voiceofkavi.png',
  },
  {
    name: '#bookworm',
    username: 'Sanav',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/dec_22_23_24/sanav.jpg',
  },
  //21dec
  {
    name: '#Guesstheaccent',
    username: 'sailu_the_one',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/dec_21/_sailu_the_one.jpg',
  },
  {
    name: '#Newme',
    username: 'selfiee_divi',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/dec_21/selfiee_divi.jpeg',
  },
  {
    name: '#MyCity',
    username: 'sreelakshmi',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/dec_21/dr+sreelakshmi.jpeg',
  },
  {
    name: '#Newme',
    username: 'jaya.life',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/dec_21/jaya_life.jpeg',
  },
  {
    name: '#newme',
    username: 'Sanav',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/dec_21/sanav.jpg',
  },
  {
    name: '#GuessTheAccent',
    username: 'listen2vin',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/dec_21/Listen2vin.jpeg',
  },
  //20dec
  {
    name: '#Kdrama',
    username: 'princey',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/dec_20/princey.jpeg',
  },
  {
    name: '#Kdrama',
    username: 'deekshu_',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/dec_20/Deekshu.jpg',
  },
  {
    name: '#AnnoyingRelatives ',
    username: 'ambili',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/dec_20/ambili.jpeg',
  },
  {
    name: '#AnnoyingRelatives ',
    username: 'swehar',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/dec_20/swehar.jpeg',
  },
  {
    name: '#Kdrama',
    username: 'aishleshaverma',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/dec_20/aishleshaverma.jpg',
  },
  {
    name: '#Kdrama',
    username: 'voiceofkavi',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/dec_20/voiceofkavi.png',
  },
  //19dec
  {
    name: '#DatingLife',
    username: 'allaboutdramas',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/dec19/allaboutdramas.jpeg',
  },
  {
    name: '#TravelDiaries ',
    username: 'divasantho ',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/dec19/divasantho+.jpeg',
  },
  {
    name: '#DatingLife',
    username: 'amrutaammu ',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/dec19/amrutaammu.jpeg',
  },
  {
    name: '#DatingLife',
    username: 'abhilashas',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/dec19/Abhilasha.jpeg',
  },
  {
    name: '#TravelDiaries ',
    username: 'fidato_',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/dec19/Fidato.jpg',
  },
  {
    name: '#TravelDiaries ',
    username: 'bhuvanaprabhu',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/dec19/_Bhuvana+Prabhu.jpeg',
  },
  //18dec
  {
    name: '#bookworm ',
    username: 'rjkalaivani',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/dec_18/rjkalaivani.jpeg',
  },
  {
    name: '#Redflag',
    username: 'deekshu_',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/dec_18/Deekshu.jpg',
  },
  {
    name: '#RedFlag',
    username: 'kcdramacorner ',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/dec19/kcdramacorner+.jpeg',
  },
  {
    name: '#RedFlag',
    username: 'sonalirc',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/dec_18/sonalirc.jpeg',
  },
  {
    name: '#bookworm ',
    username: 'skipsway ',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/dec_18/skipsway.jpeg',
  },
  {
    name: '#bookworm ',
    username: 'lavu091',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/dec_18/Lavanya.jpeg',
  },
  //17dec
  {
    name: '#WeirdFoodCombos',
    username: 'riturocks',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/dec_17/riturocks+copy.jpg',
  },
  {
    name: '#WeirdFoodCombos',
    username: 'aathanamma ',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/dec_17/_aathanamma.jpeg',
  },
  {
    name: '#SomethingNew',
    username: 'harinidoddamane',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/dec_17/Harini+Kannada.jpeg',
  },
  {
    name: '#WeirdFoodCombos',
    username: 'aparna',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/dec_17/Aparna+.jpg',
  },
  {
    name: '#SomethingNew',
    username: 'fidato_',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/dec_17/Fidato.jpg',
  },
  {
    name: '#SomethingNew',
    username: 'drvenus',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/dec_17/drvenus.jpeg',
  },
  //16dec
  {
    name: '#TravelDiaries',
    username: 'sreeja',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/dec_15_16/sreeja+.jpeg',
  },
  {
    name: '#Kdrama',
    username: 'abhumijain',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/dec_15_16/abhumijain.jpeg',
  },
  {
    name: '#lovetalk',
    username: 'shagungarg',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/dec_15_16/shagungarg.jpg',
  },
  {
    name: '#TravelDiaries',
    username: 'jebajustin',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/dec_15_16/Jeba+Justin.jpeg',
  },
  {
    name: '#TravelDiaries',
    username: 'KavyaJerry',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/dec_15_16/Kavya.jpeg',
  },
  {
    name: '#TravelDiaries',
    username: 'Charusaranya',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/dec_15_16/charusaranya.jpeg',
  },
  //15dec
  {
    name: '#nostalgic',
    username: 'kikkuu',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/dec_15_16/kikkuu.jpg',
  },
  {
    name: '#nostalgic',
    username: 'pavithra96',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/dec_15_16/pavithra96.jpeg',
  },
  {
    name: '#nostalgic',
    username: 'kavya',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/dec_15_16/Kavya.jpeg',
  },
  {
    name: '#nostalgic',
    username: 'listen2vin ',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/dec_15_16/Listen2vin.jpeg',
  },
  {
    name: '#nostalgic',
    username: 'Sanav',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/dec_15_16/sanav.jpg',
  },
  {
    name: '#dailyroutine ',
    username: 'hefzi',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/dec_15_16/hefzi+.jpeg',
  },
  //14dec
  {
    name: '#mycity',
    username: 'Sanav',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/dec14/sanav.jpg',
  },
  {
    name: '#Masterchef',
    username: 'foodieniks',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/dec14/foodieniks+(1).jpg',
  },
  {
    name: '#Mastercheif ',
    username: 'subhacts',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/dec14/subhacts.jpeg',
  },
  {
    name: '#Friends',
    username: 'deekshu_',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/dec14/Deekshu.jpg',
  },
  {
    name: '#friends',
    username: 'fidato_',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/dec_15_16/Fidato.jpg',
  },
  {
    name: '#Masterchef',
    username: 'wominspire',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/dec_15_16/Revathi+Vinodh.jpeg',
  },
  //13dec
  {
    name: '#Reviewin30',
    username: 'nirugowda',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/dec13/Nirugowda.jpeg',
  },
  {
    name: '#nostalgic',
    username: 'roshna_melwin',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/dec13/Roshna+melvin.jpeg',
  },
  {
    name: '#Reviewin30',
    username: 'abhilashas',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/dec13/Abhilasha+(1).jpeg',
  },
  {
    name: '#Reviewin30',
    username: 'shagungarg',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/dec13/shagungarg.jpg',
  },
  {
    name: '#Reviewin30',
    username: 'Rj Khanishka',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/dec13/Rj+Khanishka.jpeg',
  },
  {
    name: '#Reviewin30',
    username: 'shakthi',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/dec13/shakthi.jpeg',
  },
  //12dec
  {
    name: '#Guessthesong',
    username: 'sneha_singss',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/dec13/sneha_singss.jpg',
  },
  {
    name: '#FamilyDrama',
    username: '4hanna',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/dec12/4hanna+.jpeg',
  },
  {
    name: '#badjoke',
    username: 'fidato_',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/dec12/Fidato.jpg',
  },
  {
    name: '#secretrecipe',
    username: 'listen2vin ',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/dec12/Listen2vin.jpeg',
  },
  {
    name: '#FamilyDrama',
    username: 'kavya',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/dec12/Kavya.jpeg',
  },
  {
    name: '#weddingseason',
    username: 'ssrilakshmi',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/dec12/ssrilakshmi.jpeg',
  },
  //11dec
  {
    name: '#badjoke ',
    username: 'lavu091',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/dec11/Lavanya.jpeg',
  },
  {
    name: '#Santa',
    username: 'kavya',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/dec11/Kavya.jpeg',
  },
  {
    name: '#motivation',
    username: 'Firdouz',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/dec11/Firdouz.jpeg',
  },
  {
    name: '#DinnerDate',
    username: 'kavyah',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/dec11/Kavyah.jpeg',
  },
  {
    name: '#motivation',
    username: 'ambili',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/dec11/ambili.jpeg',
  },
  {
    name: '#Fantasy',
    username: 'abhilashas',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/dec11/Abhilasha+(1).jpeg',
  },
  //10dec
  {
    name: '#AVgotTalent',
    username: 'drama_purple',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/dec10/drama_purple.jpg',
  },
  {
    name: '#weekendvibs',
    username: 'kalyani3030',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/dec10/Kalyani.jpg',
  },
  {
    name: '#AVGotTalent',
    username: 'nanuz',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/dec10/nanuz.jpeg',
  },
  {
    name: '#weekendvibes ',
    username: 'lavu091',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/dec10/Lavanya.jpeg',
  },
  {
    name: '#DoubleStandards',
    username: 'Abhumijain ',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/dec10/abhumijain.jpeg',
  },
  {
    name: '#DoubleStandards',
    username: 'jyotirj',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/dec10/jyotirj.jpeg',
  },
  //9dec
  {
    name: '#YoungerSelf',
    username: 'rj_vaseema',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/dec_8_9/rj_vaseema.jpeg',
  },
  {
    name: '#deardairy',
    username: 'fidato_',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/dec_8_9/Fidato.jpg',
  },
  {
    name: '#deardairy',
    username: 'Charusaranya',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/dec_8_9/charusaranya.jpeg',
  },
  {
    name: '#deardairy',
    username: 'arushisvoice',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/dec_8_9/arushisvoice.jpg',
  },
  {
    name: '#YoungerSelf',
    username: 'anukoya',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/dec_8_9/anukoya.jpeg',
  },
  {
    name: '#deardiary',
    username: 'somya',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/dec_8_9/somya.jpeg',
  },
  //8dec
  {
    name: '#BadJoke',
    username: 'aleena_vs',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/dec_8_9/aleena_vs.png',
  },
  {
    name: '#BadJoke',
    username: 'harinidoddamane',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/dec_8_9/Harini+Kannada.jpeg',
  },
  {
    name: '#girltalk',
    username: 'shagungarg',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/dec_8_9/shagungarg.jpg',
  },
  {
    name: '#MisheardLyrics',
    username: 'rjkalaivani',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/dec_8_9/rjkalaivani.jpeg',
  },
  {
    name: '#BadJoke',
    username: 'kavya',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/dec_8_9/Kavya.jpeg',
  },
  {
    name: '#MisheardLyrics',
    username: 'abhilashas',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/dec_8_9/Abhilasha+(1).jpeg',
  },
  //7dec
  {
    name: '#girltalk',
    username: 'anukoya',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/dec7/anukoya.jpeg',
  },
  {
    name: '#TrueSelf',
    username: 'anibha_muskan',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/dec7/anibha_muskan.png',
  },
  {
    name: '#TrueSelf',
    username: 'wominspire',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/dec7/Revathi+Vinodh.jpeg',
  },
  {
    name: '#girltalk ',
    username: '4hanna',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/dec7/4hanna+-+Aneesa.jpeg',
  },
  {
    name: '#Kdrama',
    username: 'deekshu_',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/dec7/Deekshu.jpg',
  },
  {
    name: '#girltalk',
    username: 'voiceofkavi',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/dec7/voiceofkavi.png',
  },
  //6dec
  {
    name: '#girltalk ',
    username: 'Sanav',
    imgSrc: 'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/dec6/sanav.jpg',
  },
  {
    name: '#girltalk ',
    username: 'angell',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/dec6/angell.jpg',
  },
  {
    name: '#TravelDiaries',
    username: 'kavyah',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/dec6/Kavyah.jpeg',
  },
  {
    name: '#MyMovie',
    username: 'praseetham',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/dec6/praseetham.jpeg',
  },
  {
    name: '#Mymovie',
    username: 'talkysilpa',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/dec6/talkysilpa.png',
  },
  {
    name: '#Mymovie',
    username: 'purplemochi',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/dec6/purplemochi.jpeg',
  },
  //5dec
  {
    name: '#Reviewin30',
    username: 'RjKhanishka',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/dec5/Rj+Khanishka.jpeg',
  },
  {
    name: '#Reviewin30',
    username: 'ssrilakshmi',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/dec5/ssrilakshmi.jpeg',
  },
  {
    name: '#Reviewin30',
    username: 'nirugowda',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/dec5/Nirugowda.jpeg',
  },
  {
    name: '#Reviewin30',
    username: 'sreelakshmi',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/dec5/dr+sreelakshmi.jpeg',
  },
  {
    name: '#Reviewin30',
    username: 'justveraa',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/dec5/Veraa.jpeg',
  },
  {
    name: '#Reviewin30',
    username: 'riturocks',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/dec5/riturocks.jpeg',
  },
  //4dec
  {
    name: '#weddingSeason',
    username: 'abhilashas',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/dec4/Abhilasha+(1).jpeg',
  },
  {
    name: '#Mondaymotivation',
    username: 'shagungarg',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/dec4/shagungarg.jpg',
  },
  {
    name: '#weddingSeason',
    username: 'anukoya',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/dec4/anukoya+(1).jpeg',
  },
  {
    name: '#MondayMotivatio',
    username: 'amrutaammu',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/dec4/amrutaammu.jpeg',
  },
  {
    name: '#MondayMotivation',
    username: 'shakthi',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/dec4/shakthi.jpeg',
  },
  {
    name: '#WeddingSeason',
    username: 'drvenus',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/dec4/dr+venus.jpeg',
  },
  //3dec
  {
    name: '#metime',
    username: '_fidato',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/dec3/Fidato.jpg',
  },
  {
    name: '#metime ',
    username: 'poeticlocker',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/dec3/poeticlocker.jpg',
  },
  {
    name: '#metime ',
    username: 'RJKhanishka',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/dec3/Rj+Khanishka.jpeg',
  },
  {
    name: '#MeTime',
    username: 'harinidoddamane',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/dec3/Harini+Kannada.jpeg',
  },
  {
    name: '#MeTime',
    username: 'kdlover',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/dec3/Kdlover.jpg',
  },
  {
    name: '#CoupleGoals',
    username: 'subhacts',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/dec3/subhacts.jpeg',
  },
  //2dec
  {
    name: '#metime',
    username: 'voiceofkavi',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/dec_1_2/voiceofkavi.png',
  },
  {
    name: '#weddingSeason',
    username: 'jyotirj',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/dec_1_2/jyotirj.jpeg',
  },
  {
    name: '#weddingSeason',
    username: 'aleena_vs',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/dec_1_2/aleena_vs.png',
  },
  {
    name: '#weddingSeason',
    username: 'rjyuvarani',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/dec_1_2/rjyuvarani+.jpeg',
  },
  {
    name: '#SaturdayMood',
    username: 'deekshu_',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/dec_1_2/Deekshu.jpg',
  },
  {
    name: '#weddingSeason',
    username: 'purplemochi',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/dec_1_2/purplemochi.jpeg',
  },
  //1dec
  // {
  //   name: '#siblings',
  //   username: 'anibha_muskan',
  //   imgSrc: 'imgSrc',
  // },
  {
    name: '#hireme',
    username: 'somya',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/dec_1_2/somya.jpeg',
  },
  {
    name: '#Siblings',
    username: 'rooppaghuru',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/dec_1_2/rooppaghuru.jpeg',
  },
  {
    name: '#HireMe',
    username: 'jebajustin',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/dec_1_2/Jeba+Justin.jpeg',
  },
  {
    name: '#BingeWatch',
    username: 'skipsway',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/dec_1_2/skipsway.jpeg',
  },
  {
    name: '#hireme',
    username: 'kalyani3030',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/dec_1_2/Kalyani.jpg',
  },
  //30nov
  // {
  //   name: '#CoupleGoals',
  //   username: 'aishleshaverma',
  //   imgSrc: 'imgSrc',
  // },
  {
    name: '#Lastwords',
    username: 'kalyani3030',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/winners_30nov/Kalyani.jpg',
  },
  {
    name: '#CoupleGoals',
    username: 'Charusaranya',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/winners_30nov/charusaranya.jpeg',
  },
  {
    name: '#LastWords',
    username: 'Abinandhini ',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/winners_30nov/abinandhini.jpeg',
  },
  {
    name: '#LastWords',
    username: 'Abhumijain ',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/winners_30nov/abhumijain.jpeg',
  },
  {
    name: '#LastWords',
    username: '_fidato',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/winners_30nov/Fidato.jpg',
  },
  //29nov
  {
    name: '#songspiration',
    username: 'deekshu_',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/winners_28_29nov/Deekshu.jpg',
  },
  {
    name: '#DreamJob',
    username: 'shakthi.',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/winners_28_29nov/shakthi.jpeg',
  },
  {
    name: '#songinspiration',
    username: 'roshna_melwin',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/winners_28_29nov/Roshna+melvin.jpeg',
  },
  {
    name: '#songinspiration',
    username: 'abhilashas',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/winners_28_29nov/Abhilasha+(1).jpeg',
  },
  {
    name: '#DreamJob',
    username: 'kalyani3030',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/winners_28_29nov/Kalyani.jpg',
  },
  {
    name: '#DreamJob',
    username: 'lavu091',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/winners_28_29nov/Lavanya.jpeg',
  },
  //28nov
  {
    name: '#retro',
    username: 'abhilashas',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/winners_28_29nov/Abhilasha+(1).jpeg',
  },
  {
    name: '#retro',
    username: 'Listen2vin',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/dec_1_2/Listen2vin.jpeg',
  },
  {
    name: '#MoneyTalk',
    username: 'Taeya',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/winners_28_29nov/taeya.jpeg',
  },
  {
    name: '#Retro',
    username: 'amrutaammu',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/winners_28_29nov/amrutaammu.jpeg',
  },
  {
    name: '#DreamyAffair',
    username: 'jebajustin ',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/winners_28_29nov/Jeba+Justin.jpeg',
  },
  {
    name: '#retro',
    username: 'Charusaranya ',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/winners_28_29nov/charusaranya.jpeg',
  },
  //27nov
  {
    name: '#Rant',
    username: 'rjdiya_07',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/winners_27nov/RJ+Diya.png',
  },
  {
    name: '#Rant',
    username: 'amrutaammu',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/winners_27nov/amrutaammu.jpeg',
  },
  {
    name: '#MeetingHeroes',
    username: 'talkysilpa',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/winners_27nov/talkysilpa.png',
  },
  {
    name: '#MeetingHeroes',
    username: 'kavya',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/winners_27nov/Kavya.jpeg',
  },
  {
    name: '#Mondaymotivation',
    username: 'rishisinghal123',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/winners_28_29nov/rishisinghal123.jpg',
  },
  {
    name: '#Mondaymotivation',
    username: 'somya ',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/winners_27nov/somya.jpeg',
  },
  //26nov
  {
    name: '#Careertalk',
    username: 'lavu091 ',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/winners_26nov/Lavanya.jpeg',
  },
  {
    name: '#Moneytalk',
    username: '_fidato ',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/winners_27nov/fidato.jpeg',
  },
  {
    name: '#CareerTalk',
    username: 'thamizhthendral ',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/winners_26nov/_tamizh+thendral.jpeg',
  },
  {
    name: '#MoneyTalk',
    username: 'nirugowda',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/winners_26nov/Nirugowda.jpeg',
  },
  {
    name: '#MoneyTalk',
    username: 'nanuz',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/winners_26nov/nanuz.jpeg',
  },
  {
    name: '#MoneyTalk',
    username: 'nagasatyasiri ',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/winners_27nov/Nagasatyarsiri.jpeg',
  },
  //25nov
  {
    name: '#OhNo',
    username: 'listen2vin ',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/winners_24_25nov/Listen2vin.jpeg',
  },
  {
    name: '#OhNo',
    username: 'rituminnie',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/winners_24_25nov/rituminnie.jpeg',
  },
  {
    name: '#SaturdayMood',
    username: 'drvenus',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/winners_24_25nov/dr+venus.jpeg',
  },
  {
    name: '#BetterMe',
    username: 'jyotirj',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/winners_26nov/jyotirj_jfif.jpeg',
  },
  {
    name: '#ohno',
    username: 'aishleshaverma',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/winners_24_25nov/aishleshaverma.jpg',
  },
  {
    name: '#BetterMe',
    username: 'kalyani3030',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/winners_26nov/Kalyani.jpg',
  },
  //24nov
  {
    name: '#DreamWedding',
    username: 'rjkalaivani',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/winners_24_25nov/rjkalaivani.jpeg',
  },
  {
    name: '#DreamWedding',
    username: 'harinidoddamane',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/winners_24_25nov/Harini+Kannada.jpeg',
  },
  {
    name: '#DatingTips',
    username: 'skipsway ',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/winners_24_25nov/skipsway.jpeg',
  },
  {
    name: '#DatingTips',
    username: 'lavu091',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/winners_24_25nov/Lavanya.jpeg',
  },
  {
    name: '#DreamWedding',
    username: 'shreya_sings',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/winners_24_25nov/shreya_sings.jpg',
  },
  {
    name: '#DreamWedding',
    username: 'Taeya',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/winners_24_25nov/taeya.jpeg',
  },
  //23nov
  {
    name: '#ThursdayMood',
    username: '_fidato',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/winners_23nov/Fidato.jpg',
  },
  {
    name: '#BadAdvice',
    username: 'pavithra96',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/winners_23nov/pavithra96.jpeg',
  },
  {
    name: '#ThursdayMood',
    username: 'listen2vin ',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/winners_23nov/Listen2vin.jpeg',
  },
  {
    name: '#ThursdayMood',
    username: 'drvenus',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/winners_23nov/dr+venus.jpeg',
  },
  {
    name: '#BadAdvice',
    username: 'riturocks',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/winners_23nov/riturocks.jpg',
  },
  {
    name: '#BadAdvice',
    username: 'sailu_the_one',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/winners_23nov/_sailu_the_one.jpg',
  },
  //22nov
  {
    name: '#TGIFailed',
    username: 'harinidoddamane',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/winners_22nov/Harini+Kannada.jpeg',
  },
  {
    name: '#TGIFailed',
    username: 'wominspire ',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/winners_22nov/Revathi+Vinodh.jpeg',
  },
  {
    name: '#TGIFailed',
    username: 'subhacts ',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/winners_22nov/subhacts.jpeg',
  },
  {
    name: '#TGIFailed',
    username: 'abhilashas',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/winners_22nov/Abhilasha+(1).jpeg',
  },
  {
    name: '#TGIFailed',
    username: 'sanav',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/winners_22nov/sanav.jpg',
  },
  {
    name: '#WednesdayMood',
    username: 'nagasatyasiri',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/winners_22nov/Copy+of+Nagasatyarsiri.jpg',
  },
  //21nov
  {
    name: '#TakeABreak',
    username: '_fidato',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/winners_21nov/Fidato.jpg',
  },
  {
    name: '#MoneyTalk',
    username: 'rjyuvarani',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/winners_21nov/IMG-20231118-WA0000.jpg',
  },
  {
    name: '#RelationshipAdvice',
    username: 'charusaranya',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/winners_21nov/charusaranya.jpeg',
  },
  {
    name: '#TakeABreak',
    username: 'kavya',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/winners_21nov/Kavya.jpeg',
  },
  {
    name: '#Moneytalk',
    username: 'abhilashas',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/winners_21nov/Abhilasha+(1).jpeg',
  },
  {
    name: '#RelationshipAdvice',
    username: 'riturocks',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/winners_21nov/riturocks+copy.jpg',
  },
  //20nov
  {
    name: '#LifeAsAMovie',
    username: 'rj_diya07',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/winners_20nov/RJ+Diya.png',
  },
  {
    name: '#MorningRoutine',
    username: 'nirugowda ',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/winners_20nov/Nirugowda.jpeg',
  },
  {
    name: '#MyManspiration',
    username: 'nanuz',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/winners_20nov/nanuz.jpeg',
  },
  {
    name: '#Morningroutine ',
    username: 'lavu091',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/winners_20nov/Lavanya.jpeg',
  },
  {
    name: '#MyManspiration',
    username: 'aishleshaverma',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/winners_20nov/aishleshaverma.jpg',
  },
  {
    name: '#DatingTips',
    username: 'purplemochi',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/winners_20nov/purplemochi.jpeg',
  },
  //19nov
  {
    name: '#firstdate',
    username: 'harinidoddamane',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/winners_19nov/Harini+Kannada.jpeg',
  },
  {
    name: '#littlethings',
    username: 'anjudas',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/winners_19nov/anjudas.png',
  },
  {
    name: '#ImaginaryLove',
    username: 'rjparvathy',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/winners_19nov/rjparvathy.jpeg',
  },
  {
    name: '#foreverromance',
    username: '_fidato',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/winners_19nov/Fidato.jpg',
  },
  {
    name: '#foreverromance',
    username: 'kalyani3030',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/winners_19nov/Kalyani.jpg',
  },
  {
    name: '#foreverromance',
    username: 'jaya.life',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/winners_19nov/jayalife.jpeg',
  },
  //18nov
  {
    name: '#moneytalk',
    username: 'abhilashas',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/winners_18nov/Abhilasha+(1).jpeg',
  },
  {
    name: '#comfortspot',
    username: 'amrutaammu',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/winners_18nov/amrutaammu.jpeg',
  },
  {
    name: '#moneytalk',
    username: 'drvenus',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/winners_18nov/dr+venus.jpeg',
  },
  {
    name: '#comfortspot',
    username: 'rjlatha',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/winners_18nov/rjlatha+(1).png',
  },
  {
    name: '#comfortspot',
    username: 'abhilashas',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/winners_18nov/Abhilasha+(1).jpeg',
  },
  {
    name: '#firstdate',
    username: 'taeya',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/winners_18nov/taeya.jpeg',
  },
  //17nov
  {
    name: '#FamilyDrama',
    username: '_fidato',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/winners_17nov/Fidato.jpg',
  },
  {
    name: '#RelationshipGoals',
    username: 'nanuz',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/winners_17nov/nanuz.jpeg',
  },
  {
    name: '#WhyRemix',
    username: 'rjyuvarani ',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/winners_17nov/rjyuvarani.jpeg',
  },
  {
    name: '#whyremix',
    username: '_fidato',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/winners_17nov/Fidato.jpg',
  },
  {
    name: '#whyremix',
    username: 'sakshibuffay',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/winners_18nov/sakshibuffay.jpg',
  },
  {
    name: '#FamilyDrama',
    username: 'kavya',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/winners_18nov/Kavya.jpeg',
  },
  //16nov
  {
    name: '#Onlinedating',
    username: 'amrutaammu',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/winners_16nov/amrutaammu.jpeg',
  },
  {
    name: '#doublestandards',
    username: 'talkysilpa',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/winners_16nov/talkysilpa.png',
  },
  {
    name: '#Dailyhabit',
    username: 'Firdouz',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/winners_16nov/Firdouz.jpeg',
  },
  {
    name: '#Onlinedating',
    username: 'lavu091',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/winners_16nov/Lavanya.jpeg',
  },
  {
    name: '#doublestandards',
    username: 'aishleshaverma',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/winners_16nov/aishleshaverma.jpg',
  },
  {
    name: '#Onlinedating',
    username: 'Taeya',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/winners_16nov/taeya.jpeg',
  },
  //15nov
  {
    name: '#90sNostalgia',
    username: 'aathanamma',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/winners_15nov/_aathanamma.jpeg',
  },
  {
    name: '#90sNostalgia',
    username: 'riturocks',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/winners_15nov/riturocks.jpg',
  },
  {
    name: '#selfcare',
    username: 'Sanav',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/winners_15nov/sanav.jpg',
  },
  {
    name: '#Datingtips',
    username: 'drvenus',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/winners_15nov/dr+venus.jpeg',
  },
  {
    name: '#90sNostalgia',
    username: 'listen2vin',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/winners_15nov/Listen2vin.jpeg',
  },
  {
    name: '#90sNostalgia',
    username: 'kavyajerry',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/winners_14nov/Kavya.jpeg',
  },
  //14nov
  {
    name: '#BhaiDooj',
    username: 'lavu091',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/winners_14nov/Lavanya.jpeg',
  },
  {
    name: '#childinyou',
    username: 'angell',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/winners_14nov/angell.jpg',
  },
  {
    name: '#sexeducation',
    username: 'listen2vin',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/winners_14nov/Listen2vin.jpeg',
  },
  {
    name: '#ChildinYou',
    username: 'wominspire',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/winners_14nov/Revathi+Vinodh.jpeg',
  },
  {
    name: '#childinyou',
    username: 'purplemochi',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/winners_14nov/purplemochi.jpeg',
  },
  {
    name: '#BreakupBlues',
    username: 'drvenus',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/winners_14nov/dr+venus.jpeg',
  },
  //13nov
  {
    name: '#MorningMantra',
    username: 'rjparvathy',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/winners_13nov/rjparvathy.jpeg',
  },
  {
    name: '#Trustissues',
    username: 'talkysilpa',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/winners_13nov/talkysilpa.png',
  },
  {
    name: '#MoneyWasted',
    username: 'nirugowda',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/winners_13nov/Nirugowda.jpeg',
  },
  {
    name: '#MorningMantra',
    username: 'aishleshaverma',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/winners_13nov/aishleshaverma.jpg',
  },
  {
    name: '#MorningMantra',
    username: 'Kavya Jerry',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/winners_14nov/Kavya.jpeg',
  },
  {
    name: '#MorningMantra ',
    username: 'Sanav',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/dusseraIn30/sanav.jpg',
  },
  //
  {
    name: '#DiwaliWish',
    username: 'harinidoddamane',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/winners_12nov/Harini+Kannada.jpeg',
  },
  {
    name: '#SundayMood',
    username: 'Anitha A',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/winners_12nov/Annie+5505+.jpeg',
  },
  {
    name: '#LoveLesson',
    username: 'talkysilpa',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/winners_12nov/talkysilpa.png',
  },
  {
    name: '#SundayMood',
    username: 'Kavya Jerry',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/winners_12nov/Kavyajerry.jpg',
  },
  {
    name: '#SundayMood',
    username: 'jaya.life',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/winners_12nov/jayalife.jpeg',
  },
  {
    name: '#lovelessons',
    username: '_fidato',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/winners_12nov/Fidato.jpg',
  },
  {
    name: '#ArreitsDiwali',
    username: 'nanuz',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/winners_12nov/nanuz.jpeg',
  },
  {
    name: '#ArreitsDiwali',
    username: 'purplemochi',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/winners_12nov/purplemochi.jpeg',
  },
  {
    name: '#ArreitsDiwali',
    username: 'listen2vin',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/winners_12nov/Listen2vin.jpeg',
  },
  {
    name: '#ArreitsDiwali',
    username: 'rjlatha',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/winners_12nov/rjlatha.png',
  },
  {
    name: '#ArreitsDiwali',
    username: 'abhilashas',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/winners_12nov/Abhilasha+(1).jpeg',
  },
  {
    name: '#ArreitsDiwali',
    username: '_fidato',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/winners_12nov/Fidato.jpg',
  },
  //
  {
    name: '#HappyDiwali',
    username: 'kavyah',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/winners_11nov/Kavyah.jpeg',
  },
  {
    name: '#HappyDiwali',
    username: 'lovedramaedit',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/winners_11nov/lovedramaedit.jpeg',
  },
  {
    name: '#HappyDiwali',
    username: 'drvenus',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/winners_11nov/dr+venus.jpeg',
  },
  {
    name: '#DiwaliDisasters',
    username: '_fidato',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/winners_11nov/Fidato.jpg',
  },
  {
    name: '#HappyDiwali',
    username: 'rjbhawna',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/winners_11nov/rjbhawna.jpg',
  },
  {
    name: '#HappyDiwali',
    username: 'purplemochi',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/winners_11nov/purplemochi.jpeg',
  },
  //
  {
    name: '#wealthwisdom',
    username: 'aish27',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/winners_11nov/Aish27.jpeg',
  },
  {
    name: '#Extraleave',
    username: 'bhuvanaprabhu',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/winners_11nov/Bhuvana+Prabhu.jpeg',
  },
  {
    name: '#wealthwisdom',
    username: 'smithasathish',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/winners_11nov/smithasathish.png',
  },
  {
    name: '#Happydiwali ',
    username: 'abhilashas',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/winners_11nov/Abhilasha+(1).jpeg',
  },
  {
    name: '#wealthwisdom',
    username: 'jyotirj',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/winners_11nov/jyotirj.jpeg',
  },
  {
    name: '#wealthwisdom',
    username: 'rj_alaknanda',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/winners_11nov/rj_alaknanda.jpg',
  },
  //
  {
    name: '#firstcrush',
    username: 'lavu091',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/winners_10Nov/Lavanya.jpeg',
  },
  {
    name: '#firstcrush',
    username: 'rjmaggie',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/winners_10Nov/rjmaggie.jpeg',
  },
  {
    name: '#ThursdayMood',
    username: 'dr venus',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/winners_10Nov/drvenus.jpeg',
  },
  {
    name: '#DeepFake',
    username: 'purplemochi',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/winners_10Nov/purplemochi.jpeg',
  },
  {
    name: '#CrackersBan',
    username: 'listen2vin',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/winners_10Nov/Listen2vin.jpeg',
  },
  {
    name: '#firstcrush',
    username: 'abhilashas',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/winners_10Nov/Abhilasha.jpeg',
  },
  //
  {
    name: '#CopyCat',
    username: 'drama_purple',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/copycat07nov23/Drama_purple.png',
  },
  {
    name: '#CopyCat',
    username: 'ssrilakshmi ',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/copycat07nov23/ssrilakshmi.jpeg',
  },
  {
    name: '#CopyCat',
    username: 'swehar',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/copycat07nov23/swehar-1.jpeg',
  },
  {
    name: '#CopyCat',
    username: 'nanuz',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/copycat07nov23/nanuz.jpeg',
  },
  {
    name: '#CopyCat',
    username: 'drvenus',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/copycat07nov23/drvenus.jpeg',
  },
  //no proper image
  // {
  //   name: '#CopyCat',
  //   username: 'sreelakshmi',
  //   imgSrc:
  //     'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/copycat07nov23/sreelakshmi.jpeg',
  // },
  {
    name: '#CopyCat',
    username: 'foodiealya',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/copycat07nov23/foodiealya.jpeg',
  },
  {
    name: '#CopyCat',
    username: 'voiceofkavi',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/copycat07nov23/voiceofkavi.png',
  },
  {
    name: '#CopyCat',
    username: 'kavyajerry',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/copycat07nov23/Kavyajerry.jpg',
  },
  {
    name: '#CopyCat',
    username: 'anibha_muskan',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/copycat07nov23/anibha_muskan.png',
  },
  {
    name: '#CopyCat',
    username: 'smithasathish',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/copycat07nov23/smithasathish.jpg',
  },
  {
    name: '#CopyCat',
    username: 'shayanibanerjee',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/copycat07nov23/shayanibanerjee.png',
  },
  {
    name: '#CopyCat',
    username: 'Deekshu',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/copycat07nov23/Copy+of+Deekshu.jpg',
  },
  {
    name: '#CopyCat',
    username: 'Aish',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/copycat07nov23/Copy+of+Aish27.jpeg',
  },
  {
    name: '#CopyCat',
    username: 'amrutaammu',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/copycat07nov23/amrutaammu.jpeg',
  },
  {
    name: '#CopyCat',
    username: 'Taeya',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/copycat07nov23/taeya.jpeg',
  },
  //repeated user
  // {
  //   name: '#CopyCat',
  //   username: 'Kavya',
  //   imgSrc:
  //     'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/copycat07nov23/Kavya.jpeg',
  // },
  {
    name: '#CopyCat',
    username: 'Nagasatyasiri',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/copycat07nov23/Copy+of+Nagasatyarsiri.jpg',
  },
  //#FridayMood#HolloweenMood#SundayMood#CelebMood#FestiveMood
  {
    name: '#FridayMood',
    username: 'swehar',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/winners02nov23/swehar.jpeg',
  },
  {
    name: '#HolloweenMood',
    username: 'rjdiya07',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/winners02nov23/Rj_diya07.png',
  },
  {
    name: '#SundayMood',
    username: 'dramapurple',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/winners02nov23/Drama_purple.png',
  },
  {
    name: '#CelebMood',
    username: 'dhanaanu',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/winners02nov23/dhananu.jpeg',
  },
  {
    name: '#FestiveMood',
    username: 'rjparvathy',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/winners02nov23/rjparvathy.jpeg',
  },
  {
    name: '#FridayMood',
    username: 'skipsway',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/winners02nov23/Skipsway.jpeg',
  },
  {
    name: '#HolloweenMood',
    username: 'drvenus',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/winners02nov23/drvenus.jpeg',
  },
  {
    name: '#SundayMood',
    username: 'sreelakshmi',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/winners02nov23/dr+sreelakshmi.jpeg',
  },
  {
    name: '#CelebMood',
    username: 'smithasathish',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/winners02nov23/smithasathish.jpeg',
  },
  {
    name: '#FestiveMood',
    username: 'amzvoice',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/winners02nov23/amzvoice.jpeg',
  },
  {
    name: '#FridayMood',
    username: 'nirugowda',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/winners02nov23/Nirugowda.jpeg',
  },
  {
    name: '#HolloweenMood',
    username: 'harinidoddamane ',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/winners02nov23/Harini+Kannada.jpeg',
  },
  {
    name: '#SundayMood',
    username: 'deekshu',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/winners02nov23/Deekshu.jpg',
  },
  {
    name: '#CelebMood',
    username: 'Kavyah',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/winners02nov23/Kavyah.jpeg',
  },
  {
    name: '#FestiveMood',
    username: 'aish27',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/winners02nov23/Aish27.jpeg',
  },
  {
    name: '#FridayMood',
    username: 'abhilashas',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/winners02nov23/Abhilasha+(1).jpeg',
  },
  {
    name: '#CelebMood',
    username: 'jyotirj',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/winners02nov23/jyotirj+(1).jpeg',
  },
  {
    name: '#FestiveMood',
    username: 'aishleshaverma',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/winners02nov23/aishleshaverma+(1).jpeg',
  },
  {
    name: '#HolloweenMood',
    username: 'sailu_the_one',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/winners02nov23/+sailu_the_one.jpg',
  },
  {
    name: '#CelebMood',
    username: 'purplemochi',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/winners02nov23/purplemochi.jpeg',
  },
  {
    name: '#FestiveMood',
    username: 'sailu_the_one',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/winners02nov23/+sailu_the_one.jpg',
  },
  {
    name: '#FridayMood',
    username: 'Kavyajerry',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/winners02nov23/Kavya.jpg',
  },
  {
    name: '#HolloweenMood',
    username: 'Sanav',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/winners02nov23/Sana.jpg',
  },
  {
    name: '#CelebMood',
    username: 'Voiceofkavi',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/winners02nov23/Kavita.png',
  },
  {
    name: '#FestiveMood',
    username: 'Fidato',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/winners02nov23/Fidato.jpg',
  },
  //#Dussehrain30
  {
    name: '#Dussehrain30',
    username: 'shakthi',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/dusseraIn30/shakthi.jpg',
  },
  {
    name: '#Dussehrain30',
    username: 'ssrilakshmi',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/dusseraIn30/ssrilakshmi.jpg',
  },
  {
    name: '#Dussehrain30',
    username: 'drama_purple',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/dusseraIn30/drama_purple.jpg',
  },
  {
    name: '#Dussehrain30',
    username: 'drvenus',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/dusseraIn30/drvenus.jpg',
  },
  {
    name: '#Dussehrain30',
    username: 'nanuz',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/dusseraIn30/nanuz.jpg',
  },
  {
    name: '#Dussehrain30',
    username: 'smithasathish ',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/dusseraIn30/smithasathish.jpg',
  },
  {
    name: '#Dussehrain30',
    username: 'harinidoddamane ',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/dusseraIn30/harinidoddamane.jpg',
  },
  {
    name: '#Dussehrain30',
    username: 'deekshu',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/dusseraIn30/Deekshu.jpg',
  },
  {
    name: '#Dussehrain30',
    username: 'Nirugowda',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/dusseraIn30/Nirugowda.jpeg',
  },
  {
    name: '#Dussehrain30',
    username: 'rj_alaknanda',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/dusseraIn30/rj_alaknanda.jpg',
  },
  {
    name: '#Dussehrain30',
    username: 'Rj Khanishka',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/dusseraIn30/Rj+Khanishka.jpeg',
  },
  {
    name: '#Dussehrain30',
    username: 'sailu_the_one',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/dusseraIn30/sailu_the_one.jpg',
  },
  {
    name: '#Dussehrain30',
    username: 'Sanav',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/dusseraIn30/sanav.jpg',
  },
  {
    name: '#Dussehrain30',
    username: 'suposedly.kajal',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/dusseraIn30/suposedly_kajal.jpg',
  },
  {
    name: '#Dussehrain30',
    username: 'abhilashas',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/dusseraIn30/abhilashas.jpg',
  },
  {
    name: '#Dussehrain30',
    username: 'shivika_siddhy',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/dusseraIn30/shivika_siddhy.jpg',
  },
  {
    name: '#Dussehrain30',
    username: 'bakbakqueen',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/dusseraIn30/bakbakqueen.jpg',
  },
  {
    name: '#Dussehrain30',
    username: 'jaya.life',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/dusseraIn30/jaya_life.jpg',
  },
  //#JokesIn30
  {
    name: '#JokesIn30',
    username: 'ushmin',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/winners20102023/Usha.jpeg',
  },
  {
    name: '#JokesIn30',
    username: 'lovedramaedit',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/winners20102023/lovedramaedit.jpeg',
  },
  {
    name: '#JokesIn30',
    username: 'shalininewton',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/winners20102023/shalininewton.jpeg',
  },
  {
    name: '#JokesIn30',
    username: 'skipsway',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/winners20102023/skipsway.jpeg',
  },
  {
    name: '#JokesIn30',
    username: 'amzvoice',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/winners20102023/Amzvoice.jpeg',
  },
  {
    name: '#JokesIn30',
    username: 'talkysilpa',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/winners20102023/talkysilpa.png',
  },
  {
    name: '#JokesIn30',
    username: 'jyotirj',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/winners20102023/jyotirj.jpeg',
  },
  {
    name: '#JokesIn30',
    username: 'dhanyaasher',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/winners20102023/dhanyaasher.jpeg',
  },
  {
    name: '#JokesIn30',
    username: 'aishleshaverma',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/winners20102023/aishleshaverma.jpeg',
  },
  {
    name: '#JokesIn30',
    username: 'abhilashas',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/winners20102023/Abhilasha.jpeg',
  },
  {
    name: '#JokesIn30',
    username: 'foodiealya',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/winners20102023/foodiealya.jpeg',
  },
  {
    name: '#JokesIn30',
    username: 'kavyajerry',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/winners20102023/Kavya.jpg',
  },
  {
    name: '#JokesIn30',
    username: 'sailu_the_one',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/winners20102023/Sailu.jpeg',
  },
  {
    name: '#JokesIn30',
    username: 'rj_alaknanda',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/winners20102023/alakanada.jpg',
  },
  {
    name: '#JokesIn30',
    username: 'nagasatyasiri',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/winners20102023/Nagasatyarsiri.jpg',
  },
  {
    name: '#JokesIn30',
    username: 'harinidoddamane ',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/winners20102023/+Harini+Kannada.jpeg',
  },
  {
    name: '#JokesIn30',
    username: 'deekshu',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/winners20102023/Deekshu.jpg',
  },
  {
    name: '#JokesIn30',
    username: 'listen2vin',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/winners20102023/Listen2vin.jpeg',
  },
  //#SecretIn30
  {
    name: '#SecretIn30',
    username: 'jebajustin',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/winners_13-10-2023/Jeba+Justin.jpeg',
  },
  {
    name: '#SecretIn30',
    username: 'Wominspire',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/winners_13-10-2023/Revathi+Vinodh.jpeg',
  },
  {
    name: '#SecretIn30',
    username: 'Vansha',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/winners_13-10-2023/vansha+-+Kokila+vani.jpeg',
  },
  {
    name: '#SecretIn30',
    username: 'Voiceofshruthy',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/winners_13-10-2023/voiceofshruthy.png',
  },
  {
    name: '#SecretIn30',
    username: 'smithasathish',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/winners_13-10-2023/smithasathish.png',
  },
  {
    name: '#SecretIn30',
    username: 'drvenus',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/winners_13-10-2023/dr+venus.jpeg',
  },
  {
    name: '#SecretIn30',
    username: 'sanskrutishares',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/winners_13-10-2023/sanskrutishares.jpeg',
  },
  {
    name: '#SecretIn30',
    username: 'bindassbhawna',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/winners_13-10-2023/bindassbhawna.jpeg',
  },
  {
    name: '#SecretIn30',
    username: 'voiceofkavi',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/winners_13-10-2023/voiceofkavi.jpeg',
  },
  {
    name: '#SecretIn30',
    username: '_fidato',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/winners_13-10-2023/Fidato.jpg',
  },
  {
    name: '#SecretIn30',
    username: 'dr.Sarika',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/winners_13-10-2023/Dr.+Sarika.jpg',
  },
  {
    name: '#SecretIn30',
    username: 'manalika',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/winners_13-10-2023/Manalika.jpg',
  },
  {
    name: '#SecretIn30',
    username: 'savageakkaya',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/winners_13-10-2023/Savage+akkaya.jpg',
  },
  {
    name: '#SecretIn30',
    username: 'kalyani3030',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/winners_13-10-2023/Kalyani.jpg',
  },
  {
    name: '#SecretIn30',
    username: 'rj_alaknanda',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/winners_13-10-2023/Rj+alakanada.jpg',
  },
  {
    name: '#SecretIn30',
    username: 'listen2vin',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/winners_13-10-2023/Listen2vin.jpeg',
  },
  {
    name: '#SecretIn30',
    username: 'aish27',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/winners_13-10-2023/Aish27.jpeg',
  },
  {
    name: '#SecretIn30',
    username: 'harinidoddamane',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/winners_13-10-2023/Harini+Kannada.jpeg',
  },
  //#ReviewIn30
  {
    name: '#ReviewIn30',
    username: 'Kavyah',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/winners_13-10-2023/Kavyah.jpeg',
  },
  {
    name: '#ReviewIn30',
    username: 'thamizhthendral',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/winners_13-10-2023/+tamizh+thendral.jpeg',
  },
  {
    name: '#ReviewIn30',
    username: 'rjdiya_07',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/winners_13-10-2023/RJ+Diya.png',
  },
  {
    name: '#ReviewIn30',
    username: 'nanuz',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/winners_13-10-2023/Nanuz.jpeg',
  },
  {
    name: '#ReviewIn30',
    username: 'roshna_melwin',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/winners_13-10-2023/Roshna+melvin.jpeg',
  },
  {
    name: '#ReviewIn30',
    username: 'voiceofshruthy',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/winners_13-10-2023/voiceofshruthy.png',
  },
  {
    name: '#ReviewIn30',
    username: 'abhilashas',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/winners_13-10-2023/Abhilasha.jpeg',
  },
  {
    name: '#ReviewIn30',
    username: 'rjnivi',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/winners_13-10-2023/Rj_Nivi.jpg',
  },
  {
    name: '#ReviewIn30',
    username: 'smpositivevi',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/winners_13-10-2023/smpositivevi.jpg',
  },
  {
    name: '#ReviewIn30',
    username: 'rjmaggie',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/winners_13-10-2023/rj_maggie.jpeg',
  },
  {
    name: '#ReviewIn30',
    username: 'foodiealya',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/winners_13-10-2023/foodiealya.jpeg',
  },
  {
    name: '#ReviewIn30',
    username: 'shagungarg',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/winners_13-10-2023/shagungarg.jpg',
  },
  {
    name: '#ReviewIn30',
    username: 'rj_alaknanda',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/winners_13-10-2023/Alaknanda.jpeg',
  },
  {
    name: '#ReviewIn30',
    username: 'Sailu_the_one',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/winners_13-10-2023/Sailu.jpeg',
  },
  {
    name: '#ReviewIn30',
    username: 'taeya_vs',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/winners_13-10-2023/taeya.jpeg',
  },
  {
    name: '#ReviewIn30',
    username: 'Harinidoddamane ',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/winners_13-10-2023/Harini+Kannada.jpeg',
  },
  {
    name: '#ReviewIn30',
    username: 'Deekshu',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/winners_13-10-2023/Deekshu.jpg',
  },
  {
    name: '#ReviewIn30',
    username: 'Nirugowda',
    imgSrc:
      'https://arre-public-assets.s3.ap-south-1.amazonaws.com/Arr%C3%A9+Voice+Fest/images/winners/winners_13-10-2023/NirugowdaL.jpeg',
  },
];
